/* global __app_id, __initial_auth_token */
// Force reload
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import TutorEleva from './TutorEleva';
import {
  Download, Trash2, Plus, FileSpreadsheet, Menu, BookOpen,
  Calendar, Users, Cloud, Loader2, GraduationCap, AlertTriangle,
  LogOut, UserCircle, ShieldCheck, Search, MapPin, Building2, TrendingUp,
  Settings, BarChart2, Lock, Save, Wifi, Mail, Eye, X, Filter, Layers, CheckSquare, FileDown, AlertOctagon, Clock, Sparkles, Edit3, Copy, ArrowLeftRight, FileText, ClipboardCheck, Home, ChevronRight, Brain, CheckCircle, Newspaper, Bus, PartyPopper, CalendarRange, RefreshCw, LinkIcon
} from 'lucide-react';
import QuestionAdapter from './QuestionAdapter';
import QuestionValidator from './QuestionValidator';
import ReformuladorProva from './ReformuladorProva';
import TeacherResources from './TeacherResources';
import TeacherEvaluation from './TeacherEvaluation';
import StudentOccurrences from './StudentOccurrences';
import GestaoEscolar from './GestaoEscolar';
import StudyGuideGenerator from './StudyGuide/StudyGuideGenerator';
import CommunityTimePanel from './CTime';
import NewTimetable from './NewTimetable';
import SchoolSyncVA from './SchoolSyncVA/SchoolSyncVA';
import QuestionaCreator from './QuestionaCreator';
import DashboardEvolucional from './DashboardEvolucional/DashboardEvolucional';
import { fetchWithGeminiResilience } from './geminiClient';
import { initializeApp, getApps, getApp, deleteApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import {
  getAuth,
  signInAnonymously,
  signInWithCustomToken,
  onAuthStateChanged,
  signOut,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { getFirestore, doc, setDoc, getDoc, onSnapshot, collection, getDocs, deleteDoc } from 'firebase/firestore';
// --- CONSTANTE API KEY ---
const apiKey = "AQ.Ab8RN6L9xqG2T6VdoL7ChC1S_aV8DS1a1UWdXhScIx9CHlwsHQ";
// --- DADOS MOCKADOS DA BNCC (Fallback para quando o CSV não existe) ---
const BNCC_SAMPLE_DATA = `Série;Disciplina;Categoria;Código;Detalhamento
6º Ano;Língua Portuguesa;Leitura;EF06LP01;Reconhecer a impossibilidade de uma neutralidade absoluta no relato de fatos e identificar diferentes graus de parcialidade/imparcialidade dados pelo recorte feito e pelos recursos linguísticos e discursivos utilizados.
6º Ano;Língua Portuguesa;Leitura;EF06LP02;Estabelecer relação entre os diferentes gêneros jornalísticos, compreendendo a centralidade da notícia.
6º Ano;Matemática;Números;EF06MA01;Comparar, ordenar, ler e escrever números naturais e números racionais cuja representação decimal é finita, fazendo uso da reta numérica.
6º Ano;Matemática;Números;EF06MA02;Reconhecer o sistema de numeração decimal, como o que prevaleceu no mundo ocidental, e destacar semelhanças e diferenças com outros sistemas, de modo a sistematizar suas principais características (base, valor posicional e função do zero), utilizando, inclusive, a composição e decomposição de números naturais e números racionais em sua representação decimal.
6º Ano;História;História: tempo, espaço e formas de registros;EF06HI01;Identificar diferentes formas de compreensão da noção de tempo e de periodização dos processos históricos (continuidades e rupturas).
6º Ano;História;História: tempo, espaço e formas de registros;EF06HI02;Identificar a gênese da produção do saber histórico e analisar o significado das fontes que originaram determinadas formas de registro em sociedades e épocas distintas.
6º Ano;Geografia;O sujeito e seu lugar no mundo;EF06GE01;Comparar modificações de paisagens nos lugares de vivência e os usos desses lugares em diferentes tempos.
6º Ano;Geografia;O sujeito e seu lugar no mundo;EF06GE02;Analisar modificações de paisagens por diferentes tipos de sociedade, com destaque para os povos originários.
6º Ano;Ciências da Natureza;Matéria e Energia;EF06CI01;Classificar como homogênea ou heterogênea a mistura de dois ou mais materiais (água e sal, água e óleo, água e areia etc.).
6º Ano;Ciências da Natureza;Matéria e Energia;EF06CI02;Identificar evidências de transformações químicas a partir do resultado de misturas de materiais que originam novas substâncias.
7º Ano;Língua Portuguesa;Leitura;EF07LP01;Distinguir diferentes propostas editoriais – de forma a identificar os recursos utilizados para impactar/chocar o leitor – que acompanham as notícias, manchetes e lides sensacionalistas.
7º Ano;Matemática;Números;EF07MA01;Resolver e elaborar problemas com números naturais, envolvendo as noções de divisor e de múltiplo, podendo incluir máximo divisor comum ou mínimo múltiplo comum, por meio de estratégias diversas, sem a aplicação de algoritmos.
8º Ano;Língua Portuguesa;Leitura;EF08LP01;Identificar e comparar as várias editorias de jornais impressos e digitais e de sites noticiosos, de forma a refletir sobre os tipos de fato que são noticiados e sobre as escolhas do que noticiar.
9º Ano;Física;Matéria e Energia;EF09CI01;Investigar as mudanças de estado físico da matéria e explicar essas transformações com base no modelo de constituição submicroscópica.
1ª Série EM;Matemática;Álgebra;EM13MAT101;Interpretar criticamente situações econômicas, sociais e fatos relativos às Ciências da Natureza que envolvam a variação de grandezas, pela análise dos gráficos das funções apresentadas e/ou da taxa de variação, com ou sem apoio de tecnologias digitais.
1ª Série EM;Língua Portuguesa;Campo da vida pessoal;EM13LGG101;Compreender e analisar processos de produção e circulação de discursos, nas diferentes linguagens, para fazer escolhas fundamentadas em função de interesses pessoais e coletivos.
`;
// --- CONFIGURAÇÃO DO FIREBASE ---
const firebaseConfig = {
  apiKey: "AIzaSyBrW-uRpfg5WPaGMXtVTf0YpYVB7SzLGXM",
  authDomain: "eleva-system.firebaseapp.com",
  projectId: "eleva-system",
  storageBucket: "eleva-system.firebasestorage.app",
  messagingSenderId: "125044665159",
  appId: "1:125044665159:web:e04352bd2b87197df13a62"
  // measurementId: "G-MLY8TVBCK7" // Desativado para evitar erro 400 em ambiente local
};
// Identificador do App
const getGlobalAppId = () => {
  let id = 'planejamentomopi';
  if (typeof window !== 'undefined' && window.__app_id) {
    id = window.__app_id;
  }
  return id.replace(/[^a-zA-Z0-9_-]/g, '_');
};
const appId = getGlobalAppId();
// Variável global para a API Key
const globalApiKey = typeof apiKey !== 'undefined' ? apiKey : "";
let app, auth, db;
let firebaseInitError = null;
try {
  app = getApps().find(a => a.name === '[DEFAULT]') || initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  
  // Inicialização segura do Analytics
  if (firebaseConfig.measurementId && typeof window !== 'undefined') {
    try {
      getAnalytics(app);
    } catch (analyticsError) {
      console.warn("Firebase Analytics não pôde ser inicializado:", analyticsError);
    }
  }
} catch (e) {
  console.error("Erro na inicialização do Firebase:", e);
  firebaseInitError = e.message || "Erro desconhecido na inicialização.";
}
// --- CONSTANTES GERAIS ---
const DISCIPLINAS_MASTER = [
  "Língua Portuguesa", "Matemática", "História", "Geografia",
  "Language and Arts", "Ciências da Natureza", "Biologia",
  "Química", "Física", "Filosofia", "Sociologia",
  "Literatura", "Arte", "Physical Education",
  "Public Speaking", "Drama", "Creative Tech", "Music",
  "Atualidades", "IB Biology", "IB Business",
  "BSS História", "Math AI", "BSS Geografia", "Filosofia/ Sociologia"
];
const SERIES = [
  "6º Ano", "7º Ano", "8º Ano", "9º Ano",
  "10º Ano", "11º Ano", "12º Ano"
];
const UNIDADES = ["Itanhangá", "Tijuca"];
const TRIMESTRES = ["1º Trimestre", "2º Trimestre", "3º Trimestre"];
// Mapeamento de Turmas por Série
const CLASSES_BY_GRADE = {
  "6º Ano": ["6A", "6B", "6C", "6D"],
  "7º Ano": ["7A", "7B", "7C"],
  "8º Ano": ["8A", "8B", "8C", "8D"],
  "9º Ano": ["9A", "9B", "9C", "9D"]
};
const DEFAULT_CONFIG = {
  pass_master: 'Master888',
  pass_itanhanga: 'Itanhanga123',
  pass_tijuca: 'Tijuca123',
  gemini_api_key: 'AQ.Ab8RN6L9xqG2T6VdoL7ChC1S_aV8DS1a1UWdXhScIx9CHlwsHQ'
};
const MOPI_LOGO = "https://i.postimg.cc/Vs77fcRR/Logo_Escola_Eleva_Barra_Horizontal_Inspired.png";
const MOPI_LOGO_PDF = "https://i.postimg.cc/Vs77fcRR/Logo_Escola_Eleva_Barra_Horizontal_Inspired.png"; // Nova constante para o logo do PDF
// --- FUNÇÃO PARA PARSEAR CSV ---
const parseCSV = (csvText) => {
  if (!csvText) return [];
  const lines = csvText.trim().split('\n');
  // lines[0] é o cabeçalho, começamos do 1
  return lines.slice(1).map(line => {
    const values = line.split(';');
    // Se a linha estiver vazia ou mal formatada, ignora
    if (values.length < 5) return null;
    // Limpeza básica para remover espaços extras e quebras de linha indesejadas
    const codigo = values[3] ? values[3].trim() : "";
    const detalhamento = values[4] ? values[4].trim() : "";
    // --- NORMALIZAÇÃO DE SÉRIE ---
    // O CSV pode vir com "9º ano EF", "1ª série", etc. O sistema usa "9º Ano", "1ª Série EM".
    let serieRaw = values[0].trim();
    let serieNormalized = serieRaw;
    if (serieRaw.match(/9[º°] ano/i)) serieNormalized = "9º Ano";
    else if (serieRaw.match(/1[ªa] s[ée]rie/i)) serieNormalized = "10th Grade";
    else if (serieRaw.match(/2[ªa] s[ée]rie/i)) serieNormalized = "11th Grade";
    else if (serieRaw.match(/3[ªa] s[ée]rie/i)) serieNormalized = "12th Grade";
    else if (serieRaw.match(/6[º°] ano/i)) serieNormalized = "6º Ano";
    else if (serieRaw.match(/7[º°] ano/i)) serieNormalized = "7º Ano";
    else if (serieRaw.match(/8[º°] ano/i)) serieNormalized = "8º Ano";
    return {
      serie: serieNormalized,
      disciplina: values[1].trim(),
      categoria: values[2].trim(),
      codigo: codigo,
      detalhamento: detalhamento,
      // Cria um valor unificado para o <option>
      fullValue: `${codigo} - ${detalhamento}`,
      fullLabel: `(${codigo}) ${detalhamento}`
    };
  }).filter(item => item !== null);
};
// --- HELPERS PARA PDF ---
const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return resolve();
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};
const loadPDFLibs = async () => {
  if (!window.jspdf) {
    await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");
  }
  if (!window.jspdf.plugin?.autotable) {
    await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.1/jspdf.plugin.autotable.min.js");
  }
  // Fallback check
  if (!window.jspdf) throw new Error("Falha ao carregar biblioteca PDF. Verifique sua conexão.");
};
// --- HELPER PARA CARREGAR IMAGEM PARA O PDF ---
const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous"; // Importante para evitar problemas de CORS
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      // Tenta converter para PNG, se falhar, tenta JPEG
      try {
        resolve(canvas.toDataURL('image/png'));
      } catch (e) {
        resolve(canvas.toDataURL('image/jpeg'));
      }
    };
    img.onerror = (error) => {
      console.warn(`Erro ao carregar imagem do logo (${url}):`, error);
      // Resolve com null para não quebrar a geração do PDF se a imagem falhar
      resolve(null);
    };
    img.src = url;
  });
};
const getSubjectsForGrade = (grade) => {
  // Regra Específica para Ensino Médio (10º, 11º e 12º Ano)
  if (["10º Ano", "11º Ano", "12º Ano"].includes(grade)) {
    return [
      "Geografia",
      "Atualidades",
      "Química",
      "Física",
      "Matemática",
      "Biologia",
      "IB Biology",
      "IB Business",
      "BSS História",
      "Math AI",
      "BSS Geografia",
      "Filosofia/ Sociologia",
      "História",
      "Língua Portuguesa"
    ];
  }

  // Lógica Existente para Fundamental 2
  const isEM = grade.includes("Grade"); // Mantendo compatibilidade com nomes antigos se existirem
  const is9 = grade === "9º Ano";
  const isFund2 = !isEM;

  const subjects = DISCIPLINAS_MASTER.filter(d => {
    // Filtra disciplinas que não são do Fund 2 básico (ex: novas do EM não entram aqui por padrão se não forem do array original)
    // Mas agora que adicionamos ao array MASTER, precisamos filtrar.
    // Para simplificar: Se não for EM novo, usa lista restrita original.
    const isHighSchoolOnly = [
      "Atualidades", "IB Biology", "IB Business",
      "BSS História", "Math AI", "BSS Geografia", "Filosofia/ Sociologia"
    ].includes(d);

    if (isHighSchoolOnly) return false;

    if (["Biologia", "Química", "Física"].includes(d)) return is9 || isEM;
    if (["Sociologia", "Literatura", "Filosofia"].includes(d)) return isEM;
    if (d === "Ciências da Natureza") return isFund2 && !is9;
    return true;
  });

  return subjects.map(s => {
    if (grade === "6º Ano" && s === "História") return "History";
    if (grade === "7º Ano" && s === "Ciências da Natureza") return "Science";
    if (grade === "8º Ano" && s === "Matemática") return "Math";
    if (grade === "9º Ano" && s === "Geografia") return "Geography";
    return s;
  });
};


// --- COMPONENTE: TELA DE LOGIN ---
const LoginScreen = ({ onLogin, globalError }) => {
  const [adminPass, setAdminPass] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [unit, setUnit] = useState('Itanhangá'); // Restored for Admin Mode
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('teacher'); // 'teacher' or 'admin' 
  const [showPassword, setShowPassword] = useState(false);  const [isAuthReady, setIsAuthReady] = useState(false);
  // States for Google Sign In flow
  // const [showUnitModal, setShowUnitModal] = useState(false); // Eliminado
  // const [tempGoogleUser, setTempGoogleUser] = useState(null); // Eliminado

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthReady(true);
    });
    return () => unsubscribe();
  }, []);

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);
    const provider = new GoogleAuthProvider();
    try {
      console.log("Iniciando Google Login...");
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log("Usuário autenticado no Google:", user.email);
 
      // --- RESTRIÇÃO DE DOMÍNIO (Ignorada em Localhost para desenvolvimento) ---
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      const isAuthorizedEmail = 
        user.email.endsWith('@escolaeleva.com.br') || 
        user.email === 'joe.matthews@inspirededu.com' ||
        user.email === 'limathiagopuc@gmail.com' ||
        user.email === 'angela.amp96@gmail.com';

      if (!isLocalhost && !isAuthorizedEmail) {
        console.warn("Domínio não autorizado em produção:", user.email);
        await auth.signOut();
        throw new Error('Acesso não autorizado. Use seu e-mail institucional @escolaeleva.com.br');
      }
      
      if (isLocalhost && !isAuthorizedEmail) {
        console.log("Dev Mode: Ignorando restrição de domínio em localhost para:", user.email);
      }
      // -------------------------------------------------------------------------
 
      console.log("Buscando perfil no Firestore para uid:", user.uid);
      const docRef = doc(db, 'teachers', user.uid);
      const docSnap = await getDoc(docRef);
 
      if (docSnap.exists()) {
        const data = docSnap.data();
        console.log("Perfil encontrado:", data);
        onLogin({ ...data, uid: user.uid, role: 'teacher' });
      } else {
        console.log("Novo usuário, registrando...");
        await handleUnitSelect('Itanhangá', user);
      }
    } catch (err) {
      console.error("Erro Google Login:", err);
      // Melhora o feedback de erro para incluir domínios não autorizados ou configurações pendentes
      let msg = 'Erro ao conectar com Google.';
      let tip = '';

      if (err.code === 'auth/unauthorized-domain') {
        msg = 'Domínio não autorizado: ' + window.location.hostname;
        tip = 'Adicione este domínio no Firebase Console -> Authentication -> Settings.';
      } else if (err.code === 'auth/popup-closed-by-user') {
        msg = 'Login cancelado pelo usuário.';
      } else {
        msg = `Erro: ${err.message}`;
        tip = `Código: ${err.code}`;
      }

      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleUnitSelect = async (selectedUnit, userOverride = null) => {
    // Se passarmos o usuário diretamente, usamos ele. Senão, não temos user.
    const userToRegister = userOverride;
    if (!userToRegister) return;

    setLoading(true);
    try {
      const userProfile = {
        name: userToRegister.displayName || 'Professor(a)',
        email: userToRegister.email,
        unit: selectedUnit,
        role: 'teacher',
        createdAt: new Date().toISOString()
      };
      await setDoc(doc(db, 'teachers', userToRegister.uid), userProfile);
      onLogin({ ...userProfile, uid: userToRegister.uid });
    } catch (err) {
      console.error("Erro ao salvar perfil:", err);
      setError("Erro ao salvar suas informações.");
    } finally {
      setLoading(false);
    }
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    if (!auth) {
      setError('Erro crítico: Sistema não conectado ao banco de dados.');
      setLoading(false);
      return;
    }
    if (mode === 'teacher') {
      if (!email || !password) {
        setError('Por favor, preencha e-mail e senha.');
        setLoading(false);
        return;
      }
      try {
        const result = await signInWithEmailAndPassword(auth, email, password);
        const user = result.user;
        const docRef = doc(db, 'teachers', user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          onLogin({ ...docSnap.data(), uid: user.uid, role: 'teacher' });
        } else {
          // Se o usuário existe no Auth mas não no Firestore, registra como padrão
          const userProfile = {
            name: user.displayName || email.split('@')[0],
            email: user.email,
            unit: 'Itanhangá',
            role: 'teacher',
            createdAt: new Date().toISOString()
          };
          await setDoc(doc(db, 'teachers', user.uid), userProfile);
          onLogin({ ...userProfile, uid: user.uid });
        }
      } catch (err) {
        console.error("Erro Login Email/Senha:", err);
        if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
          setError('E-mail ou senha incorretos.');
        } else {
          setError(`Erro: ${err.message}`);
        }
      }
      setLoading(false);
      return;
    }

    if (mode === 'admin') {
      // Removido signInAnonymously pois está desativado no console e causando erro
      // if (!auth.currentUser) { ... }
      let config = DEFAULT_CONFIG;
      try {
        const configRef = doc(db, 'artifacts', appId, 'public', 'data', 'system_config', 'main');
        const configSnap = await getDoc(configRef);
        if (configSnap.exists()) config = configSnap.data();
        else {
          // If it doesn't exist, we try to create it, but catch if permission denied
          try { await setDoc(configRef, DEFAULT_CONFIG); } catch (e) { console.log("Cant create config", e); }
        }
      } catch (err) {
        console.warn("Using default config due to error:", err);
      }

      try {
        if (adminPass === config.pass_master || adminPass === DEFAULT_CONFIG.pass_master) {
          onLogin({ role: 'master', name: 'Coordenação Geral', email: 'master@mopi.com', unit: 'Todas' });
        } else {
          setError('Senha de coordenação incorreta.');
        }
      } catch (err) {
        console.error("Erro Login Admin Logic:", err);
        setError(`Erro: ${err.message}`);
      }
      setLoading(false);
      return;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-slate-200 animate-in fade-in zoom-in duration-300 relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-blue-600 to-emerald-500"></div>
        <div className="flex justify-center mb-8 mt-2">
          <img src={MOPI_LOGO} alt="MOPI Logo" className="h-16 object-contain" />
        </div>
        <h1 className="text-xl font-bold text-center text-slate-800 mb-1">Sistema do Professor</h1>
        <p className="text-center text-slate-500 mb-8 text-sm">Área de Acesso</p>
        <div className="flex bg-slate-100 p-1 rounded-lg mb-6">
          <button
            onClick={() => { setMode('teacher'); setError(''); }}
            className={`flex-1 py-2 text-sm font-medium rounded-md transition-all ${mode === 'teacher' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
          >
            Sou Professor
          </button>
          <button
            onClick={() => { setMode('admin'); setError(''); }}
            className={`flex-1 py-2 text-sm font-medium rounded-md transition-all ${mode === 'admin' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
          >
            Coordenação
          </button>
        </div>
        <form onSubmit={handleLogin} className="space-y-5">
          {mode === 'teacher' ? (
            <div className="space-y-4">
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2 ml-1">E-mail</label>
                  <div className="relative">
                    <Mail className="w-5 h-5 absolute left-3 top-3 text-slate-400" />
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="seu.email@escolaeleva.com.br"
                      className="w-full pl-10 p-3 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2 ml-1">Senha</label>
                  <div className="relative">
                    <Lock className="w-5 h-5 absolute left-3 top-3 text-slate-400" />
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Sua senha"
                      className="w-full pl-10 pr-10 p-3 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-3 text-slate-400 hover:text-slate-600"
                    >
                      {showPassword ? <X className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                    </button>
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-all shadow-md active:scale-95 flex justify-center items-center gap-2"
                >
                  {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Entrar no Sistema'}
                </button>
              </div>

              <div className="relative py-2">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-slate-200"></div>
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-white px-2 text-slate-400 font-medium">Ou continue com</span>
                </div>
              </div>

              <button
                type="button"
                onClick={handleGoogleLogin}
                disabled={loading}
                className="w-full py-3 bg-white border border-slate-200 hover:bg-slate-50 hover:border-slate-300 text-slate-700 font-bold rounded-lg transition-all flex items-center justify-center gap-2 shadow-sm"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.84z" />
                  <path fill="#EA4335" d="M12 4.36c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 1.09 14.97 0 12 0 7.7 0 3.99 2.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
                Google Workspace
              </button>
            </div>
          ) : (
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase mb-2 ml-1">Senha de Acesso</label>
              <div className="relative">
                <ShieldCheck className="w-5 h-5 absolute left-3 top-3 text-slate-400" />
                <input
                  type="password"
                  value={adminPass}
                  onChange={(e) => setAdminPass(e.target.value)}
                  placeholder="Senha Master ou da Unidade"
                  className="w-full pl-10 p-3 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                />
              </div>
              <button
                type="submit"
                disabled={loading || !isAuthReady}
                className="w-full py-3 mt-4 font-bold rounded-lg shadow-md transition-all flex justify-center items-center gap-2 transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 shadow-blue-200"
              >
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Acessar Painel'}
              </button>
            </div>
          )}

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2 text-red-700 animate-in fade-in slide-in-from-top-1">
              <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
              <div className="text-xs">
                <p className="font-bold">Falha no Acesso</p>
                <p>{error}</p>
              </div>
            </div>
          )}
        </form>



        <div className="mt-6 text-center">
          <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${isAuthReady ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`}>
            {isAuthReady ? <Wifi className="w-3 h-3" /> : <Loader2 className="w-3 h-3 animate-spin" />}
            {isAuthReady ? "Sistema Online" : "Conectando..."}
          </div>
        </div>
      </div>
    </div>
  );
};
// --- COMPONENTE: CONFIGURAÇÕES DO SISTEMA ---
const SystemSettings = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);
  useEffect(() => {
    if (!db) return;
    const fetchConfig = async () => {
      try {
        const configRef = doc(db, 'artifacts', appId, 'public', 'data', 'system_config', 'main');
        const snap = await getDoc(configRef);
        if (snap.exists()) setConfig(snap.data());
        else setConfig(DEFAULT_CONFIG);
      } catch (e) {
        console.error("Erro ao carregar configurações:", e);
        setConfig(DEFAULT_CONFIG);
      }
      setLoading(false);
    };
    fetchConfig();
  }, []);
  const handleSave = async () => {
    if (!db) return;
    setSaving(true);
    try {
      const configRef = doc(db, 'artifacts', appId, 'public', 'data', 'system_config', 'main');
      await setDoc(configRef, config);
      setMessage({ type: 'success', text: 'Configurações atualizadas com sucesso!' });
    } catch (e) {
      setMessage({ type: 'error', text: 'Erro ao salvar.' });
    }
    setSaving(false);
    setTimeout(() => setMessage(null), 3000);
  };
  const handleResetSystem = async () => {
    if (!db) return;
    if (!window.confirm("PERIGO: Você está prestes a APAGAR TODOS OS PLANEJAMENTOS de todas as unidades e todos os professores.\n\nIsso zerará o sistema para o início do ano letivo.\n\nTem certeza absoluta que deseja continuar?")) {
      return;
    }
    const verification = window.prompt("Para confirmar esta ação destrutiva, digite APAGAR TUDO (em maiúsculas) na caixa abaixo:");
    if (verification !== "APAGAR TUDO") {
      alert("Texto de confirmação incorreto. Operação cancelada.");
      return;
    }
    setSaving(true);
    try {
      const collections = ['planners_itanhanga', 'planners_tijuca'];
      let deletedCount = 0;
      for (const colName of collections) {
        const colRef = collection(db, 'artifacts', appId, 'public', 'data', colName);
        const snapshot = await getDocs(colRef);
        const deletePromises = snapshot.docs.map(doc => deleteDoc(doc.ref));
        await Promise.all(deletePromises);
        deletedCount += snapshot.size;
      }
      setMessage({ type: 'success', text: `Sistema reiniciado com sucesso! ${deletedCount} arquivos foram removidos.` });
    } catch (e) {
      console.error(e);
      setMessage({ type: 'error', text: 'Erro ao tentar limpar o banco de dados.' });
    }
    setSaving(false);
  };
  if (loading) return <div className="p-8 text-center text-slate-500">Carregando configurações...</div>;
  return (
    <div className="max-w-3xl mx-auto space-y-8 animate-in fade-in slide-in-from-bottom-4">
      <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-200">
        <div className="flex items-center gap-3 mb-6 pb-6 border-b border-slate-100">
          <div className="p-2 bg-slate-100 rounded-lg text-slate-600">
            <Settings className="w-6 h-6" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-800">Configurações Gerais</h2>
            <p className="text-sm text-slate-500">Credenciais e acessos</p>
          </div>
        </div>
        <div className="space-y-6">
          <div className="bg-purple-50 p-4 rounded-lg border border-purple-100">
            <div className="flex items-center gap-2 mb-2 text-purple-800 font-bold">
              <Sparkles className="w-4 h-4" /> Inteligência Artificial (Gemini)
            </div>
            <p className="text-xs text-purple-600 mb-3">
              Para que a "Varinha Mágica" funcione em produção, insira aqui sua chave de API do Google Gemini.
              <br />
              <a href="https://aistudio.google.com/app/apikey" target="_blank" rel="noreferrer" className="underline hover:text-purple-900">Gerar chave gratuita</a>
            </p>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-3 text-purple-400" />
              <input
                type="password"
                value={config.gemini_api_key || ''}
                onChange={(e) => setConfig({ ...config, gemini_api_key: e.target.value })}
                placeholder="Cole sua API Key aqui (começa com AIza...)"
                className="w-full pl-9 p-3 bg-white border border-purple-200 rounded-lg font-mono text-purple-800 focus:ring-2 focus:ring-purple-500 outline-none text-sm"
              />
            </div>
          </div>
          <div className="grid gap-4 pt-4 border-t border-slate-100">
            <h3 className="font-bold text-slate-700 text-sm">Senhas de Acesso da Coordenação</h3>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Senha Master (Geral)</label>
              <div className="relative">
                <Lock className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
                <input
                  type="text"
                  value={config.pass_master}
                  onChange={(e) => setConfig({ ...config, pass_master: e.target.value })}
                  className="w-full pl-9 p-3 bg-slate-50 border border-slate-200 rounded-lg font-mono text-slate-700 focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            </div>
          </div>
          <div className="pt-4 flex items-center justify-between">
            {message && message.type !== 'error' ? (
              <span className="text-sm font-medium text-emerald-600">{message.text}</span>
            ) : <span></span>}
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm flex items-center gap-2 transition-colors disabled:opacity-50"
            >
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>
      <div className="bg-red-50 p-8 rounded-xl shadow-sm border border-red-200">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-red-100 rounded-lg text-red-600">
            <AlertOctagon className="w-6 h-6" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-red-800">Zona de Perigo</h2>
            <p className="text-sm text-red-600">Ações destrutivas e irreversíveis</p>
          </div>
        </div>
        <p className="text-sm text-red-700 mb-6 leading-relaxed">
          A ação abaixo irá apagar <strong>todos os planejamentos</strong> criados pelos professores em todas as unidades.
          Isso é recomendado apenas na troca de ano letivo. Certifique-se de ter baixado o Mapa Geral (Backup) antes de prosseguir.
        </p>
        <div className="flex justify-between items-center">
          {message && message.type === 'error' && (
            <span className="text-sm font-bold text-red-600">{message.text}</span>
          )}
          <span className="flex-1"></span>
          <button
            onClick={handleResetSystem}
            disabled={saving}
            className="px-6 py-2 bg-white border border-red-300 text-red-600 hover:bg-red-600 hover:text-white font-bold rounded-lg shadow-sm flex items-center gap-2 transition-all disabled:opacity-50"
          >
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}
            REINICIAR SISTEMA (APAGAR TUDO)
          </button>
        </div>
      </div>
    </div>
  );
};
// --- MODAL DE VISUALIZAÇÃO DE PLANO ---
const ViewPlanModal = ({ plan, onClose }) => {
  if (!plan) return null;
  const rows = plan.rows || [];
  const executed = rows.filter(r => r.status === 'Executado').length;
  const progress = rows.length ? Math.round((executed / rows.length) * 100) : 0;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200">
        <div className="bg-slate-900 text-white p-6 border-b border-slate-800 flex justify-between items-start">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <h2 className="text-xl font-bold">{plan.subject}</h2>
              <span className="px-2 py-0.5 rounded bg-blue-600 text-xs font-bold">{plan.grade}</span>
              <span className="px-2 py-0.5 rounded bg-slate-700 text-xs text-slate-300">{plan.trimestre}</span>
            </div>
            <div className="text-sm text-slate-400 flex gap-4">
              <span>Última edição: <strong className="text-white">{plan.lastEditor || plan.teacherName}</strong></span>
              <span>Unidade: <strong className="text-white">{plan.originUnit}</strong></span>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-slate-800 rounded-full transition-colors">
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="h-1 bg-slate-100 w-full">
          <div className="h-full bg-emerald-500" style={{ width: `${progress}%` }}></div>
        </div>
        <div className="flex-1 overflow-auto p-6 bg-slate-50">
          <table className="w-full text-left text-sm bg-white shadow-sm border border-slate-200 rounded-lg overflow-hidden">
            <thead className="bg-slate-100 text-slate-600 font-semibold uppercase text-xs">
              <tr>
                <th className="p-4 border-b w-16 text-center">Sem.</th>
                <th className="p-4 border-b w-1/3">Objetivo</th>
                <th className="p-4 border-b w-1/4">Sequência Didática</th>
                <th className="p-4 border-b w-1/4">Objeto</th>
                <th className="p-4 border-b">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((row) => {
                // Tenta fazer o parse do objetivo, se for JSON, mostra as tags. Se não for, mostra o texto simples.
                let objectiveContent = row.objective;
                try {
                  const parsed = JSON.parse(row.objective);
                  if (Array.isArray(parsed)) {
                    objectiveContent = (
                      <div className="flex flex-wrap gap-1">
                        {parsed.map((obj, i) => (
                          <span key={i} className="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700 border border-blue-200">
                            {obj.split(' - ')[0]}
                          </span>
                        ))}
                      </div>
                    );
                  }
                } catch (e) {
                  // Se falhar, é texto livre.
                }
                return (
                  <tr key={row.id} className="hover:bg-slate-50">
                    <td className="p-3 text-center font-bold text-slate-600 border-r">{row.week}</td>
                    <td className="p-3 border-r align-top whitespace-pre-wrap">{objectiveContent}</td>
                    <td className="p-3 border-r align-top whitespace-pre-wrap">{row.assessment}</td>
                    <td className="p-3 border-r align-top whitespace-pre-wrap">{row.knowledgeObject}</td>
                    <td className="p-3 align-top">
                      <span className={`px-2 py-1 rounded text-xs font-bold 
                        ${row.status === 'Executado' ? 'bg-green-100 text-green-700' :
                          row.status === 'Atrasado' ? 'bg-red-100 text-red-700' :
                            row.status === 'Adiado' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-600'}`}>
                        {row.status}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
// --- NOVO COMPONENTE: VISÃO GERAL DA SÉRIE (DASHBOARD AMPLO) ---
const GradeOverview = ({ planners, selectedGrade, selectedTrimestre, filterSubjects }) => {
  const weeksMap = useMemo(() => {
    const map = {};
    for (let i = 1; i <= 12; i++) map[i] = [];
    planners.forEach(p => {
      if (p.grade === selectedGrade && p.trimestre === selectedTrimestre) {
        if (filterSubjects.length === 0 || filterSubjects.includes(p.subject)) {
          if (p.rows) {
            p.rows.forEach(row => {
              if (map[row.week]) {
                map[row.week].push({
                  subject: p.subject,
                  ...row
                });
              }
            });
          }
        }
      }
    });
    return map;
  }, [planners, selectedGrade, selectedTrimestre, filterSubjects]);
  const activeWeeks = Object.entries(weeksMap).filter(([_, items]) => items.some(i => i.objective || i.knowledgeObject));
  if (activeWeeks.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-dashed border-slate-300 text-slate-400">
        <FileSpreadsheet className="w-12 h-12 mb-3 opacity-20" />
        <p>Nenhum planejamento encontrado para {selectedGrade} - {selectedTrimestre}.</p>
        {filterSubjects.length > 0 && <p className="text-xs mt-2">Tente limpar o filtro de disciplinas.</p>}
      </div>
    );
  }
  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      {activeWeeks.map(([weekNum, items]) => (
        <div key={weekNum} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <div className="bg-slate-50 px-6 py-4 border-b border-slate-200 flex items-center justify-between">
            <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
              <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">Semana {weekNum}</span>
            </h3>
            <span className="text-xs text-slate-400 font-medium">{items.length} disciplinas planejadas</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 p-6 bg-slate-50/30">
            {items.map((item, idx) => (
              item.objective || item.knowledgeObject ? (
                <div key={idx} className="bg-white p-4 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow group">
                  <div className="flex justify-between items-start mb-3 border-b border-slate-100 pb-2">
                    <span className="font-bold text-blue-700 text-sm">{item.subject}</span>
                    <span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded ${item.status === 'Executado' ? 'bg-green-50 text-green-600' :
                      item.status === 'Atrasado' ? 'bg-red-50 text-red-600' :
                        'bg-gray-50 text-gray-500'
                      }`}>
                      {item.status}
                    </span>
                  </div>
                  <div className="space-y-3">
                    {item.objective && (
                      <div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase mb-0.5">Objetivo</p>
                        <p className="text-xs text-slate-700 line-clamp-3 leading-relaxed">{item.objective}</p>
                      </div>
                    )}
                    {item.knowledgeObject && (
                      <div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase mb-0.5">Objeto de Conhecimento</p>
                        <p className="text-xs text-slate-600 line-clamp-2 leading-relaxed">{item.knowledgeObject}</p>
                      </div>
                    )}
                  </div>
                </div>
              ) : null
            ))}
          </div>
        </div>
      ))}
    </div >
  );
};
// --- CONSTANTE DESCRITORES SOLO (MOVIDA PARA ESCOPO GLOBAL) ---
const SOLO_DESCRIPTORS = {
  solo2: {
    label: '2. Condução da Aula',
    desc: 'Avalia a progressão cognitiva.',
    options: [
      { val: '0', text: 'Aula permite apenas execução mecânica (0–1)' },
      { val: '1', text: 'Aula permite apenas execução mecânica (0–1)' },
      { val: '2', text: 'Explora múltiplos conceitos (2)' },
      { val: '3', text: 'Conecta ideias e constrói sentido (3–4)' },
      { val: '4', text: 'Conecta ideias e constrói sentido (3–4)' },
      { val: '5', text: 'Estimula generalização/reflexão (5)' }
    ]
  },
  solo3: {
    label: '3. Domínio da Turma',
    desc: 'Gestão favorece complexidade?',
    options: [
      { val: '0', text: 'Disrupção impede aprendizagem (0)' },
      { val: '1', text: 'Aula controlada, mas passiva (1–2)' },
      { val: '2', text: 'Aula controlada, mas passiva (1–2)' },
      { val: '3', text: 'Ambiente favorece trocas cognitivas (3–4)' },
      { val: '4', text: 'Ambiente favorece trocas cognitivas (3–4)' },
      { val: '5', text: 'Alunos regulam e ampliam o debate (5)' }
    ]
  },
  solo4: {
    label: '4. Metodologia',
    desc: 'Adequação à faixa etária.',
    options: [
      { val: '0', text: 'Metodologia desalinhada (0–1)' },
      { val: '1', text: 'Metodologia desalinhada (0–1)' },
      { val: '2', text: 'Adequada, mas transmissiva (2)' },
      { val: '3', text: 'Favorece relações entre conceitos (3–4)' },
      { val: '4', text: 'Favorece relações entre conceitos (3–4)' },
      { val: '5', text: 'Estimula abstração e transferência (5)' }
    ]
  },
  solo5: {
    label: '5. Clareza Conceitual',
    desc: 'Domínio do conteúdo.',
    options: [
      { val: '0', text: 'Explicações fragmentadas (0–1)' },
      { val: '1', text: 'Explicações fragmentadas (0–1)' },
      { val: '2', text: 'Conteúdo correto, mas isolado (2)' },
      { val: '3', text: 'Conceitos conectados (3–4)' },
      { val: '4', text: 'Conceitos conectados (3–4)' },
      { val: '5', text: 'Ampliação conceitual e analogias (5)' }
    ]
  },
  solo6: {
    label: '6. Engajamento',
    desc: 'Participação cognitiva.',
    options: [
      { val: '0', text: 'Alunos passivos (0–1)' },
      { val: '1', text: 'Alunos passivos (0–1)' },
      { val: '2', text: 'Participação pontual (2)' },
      { val: '3', text: 'Construção coletiva (3–4)' },
      { val: '4', text: 'Construção coletiva (3–4)' },
      { val: '5', text: 'Alunos formulam hipóteses/reflexões (5)' }
    ]
  },
  solo7: {
    label: '7. Recursos Didáticos',
    desc: 'Apoio ao raciocínio.',
    options: [
      { val: '0', text: 'Recursos não contribuem (0–1)' },
      { val: '1', text: 'Recursos não contribuem (0–1)' },
      { val: '2', text: 'Recursos ilustrativos (2)' },
      { val: '3', text: 'Recursos estruturam o raciocínio (3–4)' },
      { val: '4', text: 'Recursos estruturam o raciocínio (3–4)' },
      { val: '5', text: 'Recursos ampliam abstração (5)' }
    ]
  },
  solo8: {
    label: '8. Avaliação Formativa',
    desc: 'Checagem durante a aula.',
    options: [
      { val: '0', text: 'Não há checagem (0–1)' },
      { val: '1', text: 'Não há checagem (0–1)' },
      { val: '2', text: 'Verificação factual (2)' },
      { val: '3', text: 'Questionamentos relacionais (3–4)' },
      { val: '4', text: 'Questionamentos relacionais (3–4)' },
      { val: '5', text: 'Metacognição e feedback reflexivo (5)' }
    ]
  },
  solo9: {
    label: '9. Inclusão',
    desc: 'Atenção à diversidade.',
    options: [
      { val: '0', text: 'Aula homogênea (0–1)' },
      { val: '1', text: 'Aula homogênea (0–1)' },
      { val: '2', text: 'Ajustes pontuais (2)' },
      { val: '3', text: 'Diferenciação intencional (3–4)' },
      { val: '4', text: 'Diferenciação intencional (3–4)' },
      { val: '5', text: 'Personalização e equidade (5)' }
    ]
  },
  solo10: {
    label: '10. Postura Pedagógica',
    desc: 'Mediação e vínculo.',
    options: [
      { val: '0', text: 'Postura autoritária ou omissa (0–1)' },
      { val: '1', text: 'Postura autoritária ou omissa (0–1)' },
      { val: '2', text: 'Cordialidade básica (2)' },
      { val: '3', text: 'Incentiva a participação (3–4)' },
      { val: '4', text: 'Incentiva a participação (3–4)' },
      { val: '5', text: 'Alta expectativa e vínculo (5)' }
    ]
  }
};
// --- HELPER: GERAR PDF DA OBSERVAÇÃO ---
const generateObservationPDF = async (data, stats) => {
  try {
    await loadPDFLibs();
    if (!window.jspdf) throw new Error("Biblioteca PDF indisponível.");

    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    // --- ESTILOS (RGB) ---
    // --- ESTILOS (RGB) ---
    const blue = [149, 182, 223]; // Sky Blue
    const darkBlue = [30, 58, 95]; // Navy
    const lightGray = [248, 250, 252]; // Slate-50
    const white = [255, 255, 255];
    const veryLightBlue = [255, 255, 255]; // Header clean white

    // Helper para setar cor de forma segura
    const setFill = (color) => doc.setFillColor(color[0], color[1], color[2]);
    const setText = (color) => {
      if (Array.isArray(color)) doc.setTextColor(color[0], color[1], color[2]);
      else doc.setTextColor(color);
    };

    // --- CABEÇALHO ---
    setFill(veryLightBlue); // Fundo azul claro
    doc.rect(0, 0, 210, 30, 'F');

    // Logo
    const logoDataUrl = await loadImage(MOPI_LOGO_PDF);
    if (logoDataUrl) doc.addImage(logoDataUrl, 'PNG', 10, 5, 40, 20);

    doc.setFontSize(16); doc.setFont("helvetica", "bold"); setText(darkBlue); // Texto escuro para contraste
    doc.text("RELATÓRIO DE OBSERVAÇÃO DE AULA", 200, 18, { align: 'right' });
    doc.setFontSize(10); doc.setFont("helvetica", "normal");
    doc.text("Taxonomia SOLO - Biggs & Collis", 200, 24, { align: 'right' });

    let y = 40;

    // Info Box
    doc.setDrawColor(200, 200, 200); setFill(lightGray);
    doc.roundedRect(14, y, 182, 35, 2, 2, 'FD');

    doc.setFontSize(10); setText(50);

    const leftX = 20;
    const rightX = 110;

    // Helper text
    const writeField = (label, val, x, y) => {
      doc.setFont("helvetica", "bold"); doc.text(label, x, y);
      doc.setFont("helvetica", "normal"); doc.text(String(val || '-'), x + (doc.getStringUnitWidth(label) * 10 / doc.internal.scaleFactor) + 2, y);
    }

    doc.setFont("helvetica", "bold"); doc.text("Professor(a):", leftX, y + 8);
    doc.setFont("helvetica", "normal"); doc.text(data.teacher || '', leftX + 25, y + 8);

    doc.setFont("helvetica", "bold"); doc.text("Disciplina:", rightX, y + 8);
    doc.setFont("helvetica", "normal"); doc.text(data.subject || '', rightX + 20, y + 8);

    doc.setFont("helvetica", "bold"); doc.text("Turma:", leftX, y + 16);
    doc.setFont("helvetica", "normal"); doc.text(`${data.grade || ''} - ${data.class || ''}`, leftX + 25, y + 16);

    doc.setFont("helvetica", "bold"); doc.text("Data:", rightX, y + 16);
    doc.setFont("helvetica", "normal"); doc.text(data.date ? new Date(data.date).toLocaleDateString('pt-BR') : '', rightX + 20, y + 16);

    doc.setFont("helvetica", "bold"); doc.text("Observador:", leftX, y + 24);
    doc.setFont("helvetica", "normal"); doc.text(data.observer || '', leftX + 25, y + 24);

    y += 45;

    // Helper para verificar quebra de página
    const checkPageBreak = (heightNeeded) => {
      if (y + heightNeeded > 280) {
        doc.addPage();
        y = 20;
      }
    };

    // Objetivo
    checkPageBreak(30);
    doc.setFontSize(11); setText(darkBlue); doc.setFont("helvetica", "bold");
    doc.text("1. Objetivo de Aprendizagem", 14, y);
    y += 5;

    let objText = data.objective;
    if (objText && objText.startsWith('[')) {
      try { objText = JSON.parse(objText).map(o => o.split(' - ').slice(1).join(' - ')).join('\n• '); objText = "• " + objText; } catch (e) { }
    }

    doc.setFontSize(10); setText(40); doc.setFont("helvetica", "normal");
    const objLines = doc.splitTextToSize(objText || "Não registrado.", 180);
    checkPageBreak(objLines.length * 5 + 10);
    doc.text(objLines, 14, y);
    y += (objLines.length * 5) + 5;

    doc.setFontSize(9); setText(100);
    doc.text(`Objetivo explicitado? ${data.solo1 || 'N/A'}`, 14, y);
    y += 10;

    // Tabela
    const headers = [["Critério", "Nível", "Descrição"]];
    const tableData = Object.keys(SOLO_DESCRIPTORS || {}).map(key => {
      if (!data[key]) return null;
      const val = data[key];
      const descriptor = SOLO_DESCRIPTORS[key].options.find(o => o.val === val)?.text || '-';
      return [SOLO_DESCRIPTORS[key].label, val, descriptor.replace(/\(.*\)/, '').trim()];
    }).filter(x => x);

    if (tableData.length > 0) {
      doc.autoTable({
        startY: y,
        head: headers,
        body: tableData,
        theme: 'striped',
        headStyles: { fillColor: blue, textColor: white, halign: 'left', fontStyle: 'bold' },
        bodyStyles: { textColor: 50 },
        columnStyles: { 0: { cellWidth: 50, fontStyle: 'bold' }, 1: { halign: 'center', fontStyle: 'bold', textColor: darkBlue }, 2: { cellWidth: 115 } },
        styles: { fontSize: 9, cellPadding: 3, valign: 'middle' },
        margin: { left: 14, right: 14 }
      });
      y = doc.lastAutoTable.finalY + 15;
    }

    // Evidências
    checkPageBreak(30);
    doc.setFontSize(12); setText(darkBlue); doc.setFont("helvetica", "bold");
    doc.text("Evidências Observadas", 14, y);
    y += 6;

    doc.setFontSize(10); setText(40); doc.setFont("helvetica", "normal");
    const evidenceText = data.evidence || "Sem observações registradas.";

    // AutoTable para texto longo (melhor controle de quebra de página)
    doc.autoTable({
      startY: y,
      body: [[evidenceText]],
      theme: 'plain',
      styles: { fontSize: 10, textColor: 40, cellPadding: 0, overflow: 'linebreak' },
      margin: { left: 14, right: 14 },
      showHead: false,
      pageBreak: 'auto'
    });
    y = doc.lastAutoTable.finalY + 15;

    // Sugestões
    checkPageBreak(30);
    doc.setFontSize(12); setText(darkBlue); doc.setFont("helvetica", "bold");
    doc.text("Sugestões para Avanço", 14, y);
    y += 6;

    const suggText = data.suggestions || "Sem sugestões registradas.";
    doc.autoTable({
      startY: y,
      body: [[suggText]],
      theme: 'plain',
      styles: { fontSize: 10, textColor: 40, cellPadding: 0, overflow: 'linebreak' },
      margin: { left: 14, right: 14 },
      showHead: false,
      pageBreak: 'auto'
    });
    y = doc.lastAutoTable.finalY + 15;

    // Síntese
    checkPageBreak(40);
    setFill(lightGray); doc.setDrawColor(blue[0], blue[1], blue[2]); // Explicit RGB for draw
    doc.roundedRect(14, y, 182, 30, 2, 2, 'FD');

    doc.setFontSize(11); setText(darkBlue); doc.setFont("helvetica", "bold");
    doc.text("SÍNTESE DA AVALIAÇÃO", 105, y + 8, { align: 'center' });

    doc.setFontSize(12); setText(0);
    doc.text(`Média SOLO: ${stats.average} / 5.0`, 40, y + 20);
    doc.text(`Predominância: ${stats.predominance}`, 110, y + 20);

    // Page Numbers
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8); setText(150);
      doc.text(`Página ${i} de ${pageCount} - Gerado em ${new Date().toLocaleString()}`, 105, 290, { align: 'center' });
    }

    doc.save(`Observacao_${(data.teacher || 'Docente').replace(/ /g, '_')}_${data.date}.pdf`);

  } catch (e) {
    console.error(e);
    alert("Erro ao gerar PDF: " + e.message);
  }
};






// --- COMPONENTE: FORMULÁRIO DE OBSERVAÇÃO (SOLO) ---
const ObservationForm = ({ planners, session, initialData }) => {
  const [formData, setFormData] = useState(initialData || {
    observer: session.name || '',
    teacher: '',
    subject: DISCIPLINAS_MASTER[0],
    grade: SERIES[0],
    class: '',
    unit: session.unit === 'Todas' ? 'Itanhangá' : session.unit, // Default unit
    week: '',
    date: new Date().toISOString().split('T')[0],
    time: '',
    objective: '',
    solo1: 'N/A', // Objetivo (Sim/Não)
    solo2: 'N/A', // Condução
    solo3: 'N/A', // Domínio
    solo4: 'N/A', // Metodologia
    solo5: 'N/A', // Clareza
    solo6: 'N/A', // Engajamento
    solo7: 'N/A', // Recursos
    solo8: 'N/A', // Avaliação
    solo9: 'N/A', // Inclusão
    solo10: 'N/A', // Postura
    evidence: '',
    suggestions: ''
  });

  useEffect(() => {
    if (initialData) setFormData(initialData);
  }, [initialData]);

  const [loadingObj, setLoadingObj] = useState(false);
  const [saving, setSaving] = useState(false);
  const [geminiKey, setGeminiKey] = useState('');
  const [generating, setGenerating] = useState({ type: null }); // 'evidence' or 'suggestions'

  // --- DESCRITORES SOLO ---
  const SOLO_DESCRIPTORS = {
    solo2: {
      label: '2. Condução da Aula',
      desc: 'Avalia a progressão cognitiva.',
      options: [
        { val: '0', text: 'Aula permite apenas execução mecânica (0–1)' },
        { val: '1', text: 'Aula permite apenas execução mecânica (0–1)' },
        { val: '2', text: 'Explora múltiplos conceitos (2)' },
        { val: '3', text: 'Conecta ideias e constrói sentido (3–4)' },
        { val: '4', text: 'Conecta ideias e constrói sentido (3–4)' },
        { val: '5', text: 'Estimula generalização/reflexão (5)' }
      ]
    },
    solo3: {
      label: '3. Domínio da Turma',
      desc: 'Gestão favorece complexidade?',
      options: [
        { val: '0', text: 'Disrupção impede aprendizagem (0)' },
        { val: '1', text: 'Aula controlada, mas passiva (1–2)' },
        { val: '2', text: 'Aula controlada, mas passiva (1–2)' },
        { val: '3', text: 'Ambiente favorece trocas cognitivas (3–4)' },
        { val: '4', text: 'Ambiente favorece trocas cognitivas (3–4)' },
        { val: '5', text: 'Alunos regulam e ampliam o debate (5)' }
      ]
    },
    solo4: {
      label: '4. Metodologia',
      desc: 'Adequação à faixa etária.',
      options: [
        { val: '0', text: 'Metodologia desalinhada (0–1)' },
        { val: '1', text: 'Metodologia desalinhada (0–1)' },
        { val: '2', text: 'Adequada, mas transmissiva (2)' },
        { val: '3', text: 'Favorece relações entre conceitos (3–4)' },
        { val: '4', text: 'Favorece relações entre conceitos (3–4)' },
        { val: '5', text: 'Estimula abstração e transferência (5)' }
      ]
    },
    solo5: {
      label: '5. Clareza Conceitual',
      desc: 'Domínio do conteúdo.',
      options: [
        { val: '0', text: 'Explicações fragmentadas (0–1)' },
        { val: '1', text: 'Explicações fragmentadas (0–1)' },
        { val: '2', text: 'Conteúdo correto, mas isolado (2)' },
        { val: '3', text: 'Conceitos conectados (3–4)' },
        { val: '4', text: 'Conceitos conectados (3–4)' },
        { val: '5', text: 'Ampliação conceitual e analogias (5)' }
      ]
    },
    solo6: {
      label: '6. Engajamento',
      desc: 'Participação cognitiva.',
      options: [
        { val: '0', text: 'Alunos passivos (0–1)' },
        { val: '1', text: 'Alunos passivos (0–1)' },
        { val: '2', text: 'Participação pontual (2)' },
        { val: '3', text: 'Construção coletiva (3–4)' },
        { val: '4', text: 'Construção coletiva (3–4)' },
        { val: '5', text: 'Alunos formulam hipóteses/reflexões (5)' }
      ]
    },
    solo7: {
      label: '7. Recursos Didáticos',
      desc: 'Apoio ao raciocínio.',
      options: [
        { val: '0', text: 'Recursos não contribuem (0–1)' },
        { val: '1', text: 'Recursos não contribuem (0–1)' },
        { val: '2', text: 'Recursos ilustrativos (2)' },
        { val: '3', text: 'Recursos estruturam o raciocínio (3–4)' },
        { val: '4', text: 'Recursos estruturam o raciocínio (3–4)' },
        { val: '5', text: 'Recursos ampliam abstração (5)' }
      ]
    },
    solo8: {
      label: '8. Avaliação Formativa',
      desc: 'Checagem durante a aula.',
      options: [
        { val: '0', text: 'Não há checagem (0–1)' },
        { val: '1', text: 'Não há checagem (0–1)' },
        { val: '2', text: 'Verificação factual (2)' },
        { val: '3', text: 'Questionamentos relacionais (3–4)' },
        { val: '4', text: 'Questionamentos relacionais (3–4)' },
        { val: '5', text: 'Metacognição e feedback reflexivo (5)' }
      ]
    },
    solo9: {
      label: '9. Inclusão',
      desc: 'Atenção à diversidade.',
      options: [
        { val: '0', text: 'Aula homogênea (0–1)' },
        { val: '1', text: 'Aula homogênea (0–1)' },
        { val: '2', text: 'Ajustes pontuais (2)' },
        { val: '3', text: 'Diferenciação consciente (3–4)' },
        { val: '4', text: 'Diferenciação consciente (3–4)' },
        { val: '5', text: 'Estratégias que ampliam autonomia (5)' }
      ]
    },
    solo10: {
      label: '10. Postura Pedagógica',
      desc: 'Comunicação e relação.',
      options: [
        { val: '0', text: 'Comunicação confusa (0–1)' },
        { val: '1', text: 'Comunicação confusa (0–1)' },
        { val: '2', text: 'Clara, mas unilateral (2)' },
        { val: '3', text: 'Dialógica e relacional (3–4)' },
        { val: '4', text: 'Dialógica e relacional (3–4)' },
        { val: '5', text: 'Estimula pensamento abstrato (5)' }
      ]
    }
  };

  // Carrega chave API
  useEffect(() => {
    const fetchKey = async () => {
      try {
        const configRef = doc(db, 'artifacts', appId, 'public', 'data', 'system_config', 'main');
        const snap = await getDoc(configRef);
        if (snap.exists() && snap.data().gemini_api_key) {
          setGeminiKey(snap.data().gemini_api_key);
        }
      } catch (e) { console.error("Erro key:", e); }
    };
    fetchKey();
  }, []);

  // Busca automática do objetivo
  useEffect(() => {
    if (formData.subject && formData.grade && formData.week) {
      setLoadingObj(true);
      const foundPlan = planners.find(p =>
        p.subject === formData.subject &&
        p.grade === formData.grade &&
        p.rows && p.rows.some(r => r.week == formData.week && (r.objective && r.objective.trim().length > 0))
      );

      if (foundPlan) {
        const row = foundPlan.rows.find(r => r.week == formData.week);
        setFormData(prev => ({
          ...prev,
          objective: row.objective || '',
          teacher: !prev.teacher ? foundPlan.teacherName : prev.teacher,
          class: !prev.class ? (CLASSES_BY_GRADE[prev.grade]?.[0] || '') : prev.class
        }));
      } else {
        setFormData(prev => ({ ...prev, objective: '' }));
      }
      setLoadingObj(false);
    }
  }, [formData.subject, formData.grade, formData.week, planners]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const calculateStats = () => {
    const fields = ['solo2', 'solo3', 'solo4', 'solo5', 'solo6', 'solo7', 'solo8', 'solo9', 'solo10'];
    let sum = 0;
    let count = 0;

    fields.forEach(f => {
      const val = formData[f];
      if (val !== 'N/A') {
        sum += parseInt(val);
        count++;
      }
    });

    const average = count > 0 ? (sum / count).toFixed(1) : "0.0";

    let predominance = '';
    const avgNum = parseFloat(average);
    if (avgNum < 1) predominance = 'Pré-estrutural';
    else if (avgNum < 2) predominance = 'Uni-estrutural';
    else if (avgNum < 3) predominance = 'Multi-estrutural';
    else if (avgNum < 4.5) predominance = 'Relacional';
    else predominance = 'Estendido abstrato';

    return { average, count, predominance };
  };

  const callGemini = async (prompt) => {
    if (!geminiKey) throw new Error("Chave de API não configurada.");
    const payload = {
      contents: [{ parts: [{ text: prompt }] }]
    };
    const response = await fetchWithGeminiResilience(geminiKey, payload);
    const result = await response.json();
    if (result.error) throw new Error(result.error.message);
    return result.candidates?.[0]?.content?.parts?.[0]?.text || "";
  };

  // 1. Gerar Evidências
  const generateEvidenceWithAI = async () => {
    setGenerating({ type: 'evidence' });
    try {
      // Constrói contexto das pontuações marcadas
      let scoresContext = "";
      Object.entries(SOLO_DESCRIPTORS).forEach(([key, info]) => {
        const val = formData[key];
        if (val !== 'N/A') {
          const desc = info.options.find(o => o.val === val)?.text || "N/A";
          scoresContext += `- ${info.label}: Nível ${val} (${desc})\n`;
        }
      });

      const prompt = `
        Atue como um observador pedagógico experiente.
        Com base na seguinte avaliação SOLO de uma aula de ${formData.subject} (${formData.grade}):

        ${scoresContext}

        Objetivo da Aula: ${formData.objective || "Não informado"}

        Escreva um texto coeso e profissional para o campo "Evidências Observadas em Sala de Aula".
        Descreva comportamentos e situações hipotéticas mas realistas que justificariam essas pontuações.
        Foque em fatos observáveis. Não faça julgamentos de valor, apenas descreva a prática.
      `;

      const text = await callGemini(prompt);
      setFormData(prev => ({ ...prev, evidence: text.trim() }));
    } catch (e) {
      alert("Erro IA: " + e.message);
    }
    setGenerating({ type: null });
  };

  // 2. Gerar Sugestões
  const generateSuggestionsWithAI = async () => {
    if (!formData.evidence || formData.evidence.length < 10) {
      alert("Preencha ou gere as Evidências primeiro.");
      return;
    }
    setGenerating({ type: 'suggestions' });
    try {
      const prompt = `
        Você é um mentor pedagógico responsável por apoiar o desenvolvimento profissional de professores.

        Utilize EXCLUSIVAMENTE o texto abaixo, intitulado
        "Evidências Observadas em Sala de Aula", para gerar sugestões de avanço pedagógico.

        Texto-base:
        ${formData.evidence}

        Regras obrigatórias:
        • As sugestões devem estar diretamente relacionadas às evidências apresentadas.
        • Não repita as evidências.
        • Não faça críticas diretas.
        • Utilize linguagem construtiva, formativa e orientada à prática.
        • Organize as sugestões em tópicos claros.
        • Priorize ações possíveis de curto e médio prazo.
        • Sempre que possível, sugira estratégias didáticas, organizacionais ou metodológicas.
        • Evite termos vagos como “melhorar”, “aperfeiçoar” sem indicar COMO fazer.

        Estrutura obrigatória das sugestões:
        1. Organização e clareza didática
        2. Condução da aula e gestão da turma
        3. Metodologia e adequação à faixa etária
        4. Engajamento e participação dos estudantes
        5. Avaliação formativa e acompanhamento da aprendizagem

        Título do texto final:
        "Sugestões para Avanço Pedagógico"
      `;

      const text = await callGemini(prompt);
      setFormData(prev => ({ ...prev, suggestions: text.trim() }));
    } catch (e) {
      alert("Erro IA: " + e.message);
    }
    setGenerating({ type: null });
  };

  const handleSave = async () => {
    if (!formData.teacher || !formData.subject) {
      alert("Preencha os campos obrigatórios (Professor, Disciplina).");
      return;
    }

    // Determine the unit to save to
    // If session is specific, use it. If 'Todas' (Admin), must use the selected unit from form.
    // If Admin didn't select (default state), force 'Itanhangá' or alert? 
    // We initialized it to 'Itanhangá' if 'Todas', so it should be safe.
    const targetUnit = session.unit === 'Todas' ? formData.unit : session.unit;

    setSaving(true);
    try {
      const collectionName = `observations_${targetUnit.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "")}`;
      const docId = formData.id || `${formData.date}_${formData.teacher.replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().getTime()}`;
      const docRef = doc(db, 'artifacts', appId, 'public', 'data', collectionName, docId);

      const stats = calculateStats();

      await setDoc(docRef, {
        ...formData,
        id: docId, // Save ID
        unit: targetUnit, // Ensure unit is saved in the doc
        stats,
        lastUpdated: new Date().toISOString(),
        updatedBy: session.email
      }, { merge: true });

      alert("Observação salva com sucesso!");

    } catch (e) {
      console.error(e);
      alert("Erro ao salvar observação: " + e.message);
    }
    setSaving(false);
  };

  const generatePDF = async () => {
    setSaving(true);
    await generateObservationPDF(formData, calculateStats());
    setSaving(false);
  };

  const renderDescriptorRadios = (fieldKey) => {
    const info = SOLO_DESCRIPTORS[fieldKey];
    return (
      <div className="space-y-1 mt-2">
        {info.options.map((opt) => (
          <label key={opt.val} className={`flex items-start gap-2 p-2 rounded cursor-pointer border transition-colors ${formData[fieldKey] === opt.val ? 'bg-blue-50 border-blue-200' : 'hover:bg-slate-50 border-transparent'}`}>
            <input
              type="radio"
              name={fieldKey}
              value={opt.val}
              checked={formData[fieldKey] === opt.val}
              onChange={(e) => handleChange(fieldKey, e.target.value)}
              className="mt-1 w-4 h-4 text-blue-600 focus:ring-2 focus:ring-blue-500 shrink-0"
            />
            <div>
              <span className="font-bold text-slate-700 mr-2">{opt.val}</span>
              <span className="text-sm text-slate-600">{opt.text.replace(/\(.*\)/, '')}</span>
            </div>
          </label>
        ))}
        <label className="flex items-center gap-2 p-2 rounded cursor-pointer border border-transparent hover:bg-slate-50">
          <input type="radio" name={fieldKey} value="N/A" checked={formData[fieldKey] === 'N/A'} onChange={(e) => handleChange(fieldKey, e.target.value)} className="w-4 h-4 text-slate-400" />
          <span className="text-sm text-slate-400">Não se aplica (N/A)</span>
        </label>
      </div>
    );
  };

  return (
    <div className="max-w-5xl mx-auto p-4 sm:p-8 bg-white rounded-xl shadow-lg border border-slate-200 my-8 animate-in fade-in slide-in-from-bottom-4">
      <div className="flex items-center gap-4 mb-6 border-b border-slate-100 pb-4">
        <div className="p-3 bg-blue-100 text-blue-600 rounded-lg">
          <Eye className="w-8 h-8" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-slate-800">Nova Observação de Aula</h2>
          <div className="flex gap-2 mt-1">
            {!geminiKey && <span className="px-2 py-0.5 bg-amber-100 text-amber-700 text-xs font-bold rounded flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> IA Indisponível (Sem Chave)</span>}
            {geminiKey && <span className="px-2 py-0.5 bg-purple-100 text-purple-700 text-xs font-bold rounded flex items-center gap-1"><Sparkles className="w-3 h-3" /> IA Ativa</span>}
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Disciplina</label>
            <div className="relative">
              <BookOpen className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
              <select value={formData.subject} onChange={e => handleChange('subject', e.target.value)} className="w-full pl-9 p-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none">
                {DISCIPLINAS_MASTER.map(d => <option key={d}>{d}</option>)}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Série</label>
              <select value={formData.grade} onChange={e => handleChange('grade', e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none">
                {SERIES.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            {session.unit === 'Todas' ? (
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Unidade</label>
                <select value={formData.unit} onChange={e => handleChange('unit', e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none bg-yellow-50 border-yellow-200">
                  <option value="Itanhangá">Itanhangá</option>
                  <option value="Tijuca">Tijuca</option>
                </select>
              </div>
            ) : (
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Semana</label>
                <input type="number" value={formData.week} onChange={e => handleChange('week', e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none" placeholder="Ex: 5" />
              </div>
            )}
          </div>
          {session.unit === 'Todas' && (
            <div className="mt-4">
              <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Semana</label>
              <input type="number" value={formData.week} onChange={e => handleChange('week', e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none" placeholder="Ex: 5" />
            </div>
          )}
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Professor(a)</label>
            <div className="relative">
              <UserCircle className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
              <input type="text" value={formData.teacher} onChange={e => handleChange('teacher', e.target.value)} className="w-full pl-9 p-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none" placeholder="Nome do Professor" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Data</label>
              <input type="date" value={formData.date} onChange={e => handleChange('date', e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Turma</label>
              <input type="text" value={formData.class} onChange={e => handleChange('class', e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none" />
            </div>
          </div>
        </div>
      </div>

      <div className="mb-8 p-6 bg-slate-50 rounded-xl border border-slate-200 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-1 h-full bg-blue-500"></div>
        <h3 className="font-bold text-slate-800 mb-2">1. Objetivo de Aprendizagem (Automático)</h3>
        <div className="min-h-[50px] p-3 bg-white border border-blue-100 rounded-lg text-slate-700 text-sm shadow-sm mb-3">
          {loadingObj ? <span className="flex items-center gap-2 text-slate-400"><Loader2 className="w-4 h-4 animate-spin" /> Buscando...</span> : (
            formData.objective ? (
              formData.objective.startsWith('[') ?
                JSON.parse(formData.objective).map((o, i) => <div key={i}>• {o.split(' - ').slice(1).join(' - ')}</div>)
                : <span className="whitespace-pre-wrap">{formData.objective}</span>
            ) : <span className="text-slate-400 italic">Selecione os filtros acima.</span>
          )}
        </div>
        <div className="flex gap-4 items-center">
          <span className="text-sm font-bold text-slate-600">O objetivo foi explicitado?</span>
          {['Sim', 'Não', 'N/A'].map(opt => (
            <label key={opt} className="flex items-center gap-1 cursor-pointer">
              <input type="radio" name="solo1" value={opt} checked={formData.solo1 === opt} onChange={e => handleChange('solo1', e.target.value)} className="text-blue-600" />
              <span className="text-sm text-slate-700">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        {Object.keys(SOLO_DESCRIPTORS).map((key) => (
          <div key={key} className="bg-white border border-slate-100 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex justify-between items-start border-b border-slate-50 pb-2 mb-2">
              <h4 className="font-bold text-slate-800 text-sm">{SOLO_DESCRIPTORS[key].label}</h4>
              <span className="text-[10px] text-slate-400 uppercase font-bold tracking-wider">{SOLO_DESCRIPTORS[key].desc}</span>
            </div>
            {renderDescriptorRadios(key)}
          </div>
        ))}
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <div>
          <div className="flex justify-between items-center mb-2">
            <label className="font-bold text-slate-700 text-sm flex items-center gap-2"><Edit3 className="w-4 h-4" /> Evidências Observadas</label>
            <button
              onClick={generateEvidenceWithAI}
              disabled={!geminiKey || generating.type === 'evidence'}
              className="text-xs text-purple-600 hover:text-purple-800 font-bold flex items-center gap-1 disabled:opacity-50"
            >
              {generating.type === 'evidence' ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />}
              Gerar com IA
            </button>
          </div>
          <textarea
            value={formData.evidence}
            onChange={e => handleChange('evidence', e.target.value)}
            className="w-full h-32 p-3 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm resize-none"
            placeholder="Descreva fatos observados..."
          ></textarea>
        </div>
        <div>
          <div className="flex justify-between items-center mb-2">
            <label className="font-bold text-slate-700 text-sm flex items-center gap-2"><Sparkles className="w-4 h-4" /> Sugestões para Avanço</label>
            <button
              onClick={generateSuggestionsWithAI}
              disabled={!geminiKey || generating.type === 'suggestions'}
              className="text-xs text-purple-600 hover:text-purple-800 font-bold flex items-center gap-1 disabled:opacity-50"
            >
              {generating.type === 'suggestions' ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />}
              Gerar com IA
            </button>
          </div>
          <textarea
            value={formData.suggestions}
            onChange={e => handleChange('suggestions', e.target.value)}
            className="w-full h-32 p-3 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm resize-none"
            placeholder="Sugestões práticas para o professor..."
          ></textarea>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-end gap-3 mt-8 border-t border-slate-200 pt-6">
        <button
          onClick={handleSave}
          disabled={saving}
          className="px-6 py-3 bg-emerald-600 text-white font-bold rounded-lg hover:bg-emerald-700 transition-colors flex items-center justify-center gap-2 shadow-md shadow-emerald-200"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Salvar
        </button>
        <button
          onClick={generatePDF}
          disabled={saving}
          className="px-6 py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 shadow-md shadow-blue-200"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
          Gerar PDF
        </button>
      </div>
    </div>
  );
};

// --- COMPONENTE: HISTÓRICO E ANALYTICS DE OBSERVAÇÕES ---
const ObservationsView = ({ session, onEdit }) => {
  const [observations, setObservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeSubTab, setActiveSubTab] = useState('list'); // 'list' or 'analytics'
  const [selectedTeacher, setSelectedTeacher] = useState('Todos');
  const [viewingObs, setViewingObs] = useState(null); // State for viewing observation details

  useEffect(() => {
    const fetchObs = async () => {
      setLoading(true);
      try {
        let docs = [];
        const units = session.unit === 'Todas' ? ['Itanhangá', 'Tijuca'] : [session.unit];

        for (const unit of units) {
          const collectionName = `observations_${unit.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "")}`;
          const snap = await getDocs(collection(db, 'artifacts', appId, 'public', 'data', collectionName));
          snap.forEach(d => {
            docs.push({ id: d.id, ...d.data(), originUnit: unit });
          });
        }
        // Ordenar por data (mais recente primeiro)
        docs.sort((a, b) => new Date(b.date) - new Date(a.date));
        setObservations(docs);
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
    fetchObs();
  }, [session.unit]);

  const stats = useMemo(() => {
    if (!observations.length) return null;
    let totalScore = 0;
    let count = 0;
    const levelCounts = { 'Pré-estrutural': 0, 'Uni-estrutural': 0, 'Multi-estrutural': 0, 'Relacional': 0, 'Estendido abstrato': 0 };

    // Filtro por professor
    const filtered = selectedTeacher === 'Todos' ? observations : observations.filter(o => o.teacher === selectedTeacher);

    filtered.forEach(obs => {
      if (obs.stats) {
        totalScore += parseFloat(obs.stats.average);
        count++;
        if (obs.stats.predominance) levelCounts[obs.stats.predominance] = (levelCounts[obs.stats.predominance] || 0) + 1;
      }
    });

    const avg = count ? (totalScore / count).toFixed(2) : 0;

    // Group by Criteria (average per criteria) - requires digging into keys solo2...10
    const criteriaAvg = {};
    const criteriaCounts = {};
    filtered.forEach(obs => {
      ['solo2', 'solo3', 'solo4', 'solo5', 'solo6', 'solo7', 'solo8', 'solo9', 'solo10'].forEach(k => {
        if (obs[k] && obs[k] !== 'N/A') {
          criteriaAvg[k] = (criteriaAvg[k] || 0) + parseInt(obs[k]);
          criteriaCounts[k] = (criteriaCounts[k] || 0) + 1;
        }
      });
    });

    const criteriaResults = Object.keys(criteriaAvg).map(k => ({
      key: k,
      avg: criteriaCounts[k] ? (criteriaAvg[k] / criteriaCounts[k]).toFixed(1) : 0
    }));

    return { count, avg, levelCounts, criteriaResults, filtered };
  }, [observations, selectedTeacher]);

  const teachers = useMemo(() => [...new Set(observations.map(o => o.teacher))].sort(), [observations]);

  const handleDelete = async (obs) => {
    if (!window.confirm("Tem certeza que deseja apagar esta observação?")) return;
    try {
      const collectionName = `observations_${obs.originUnit.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "")}`;
      await deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', collectionName, obs.id));
      setObservations(prev => prev.filter(o => o.id !== obs.id));
      alert("Observação removida.");
    } catch (e) {
      alert("Erro ao remover: " + e.message);
    }
  };

  if (loading) return <div className="p-10 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-blue-500" /></div>;

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
          <Clock className="w-6 h-6 text-blue-600" /> Histórico de Observações
        </h2>
        <div className="flex bg-slate-200 p-1 rounded-lg">
          <button onClick={() => setActiveSubTab('list')} className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${activeSubTab === 'list' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-600 hover:text-slate-800'}`}>Lista</button>
          <button onClick={() => setActiveSubTab('analytics')} className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${activeSubTab === 'analytics' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-600 hover:text-slate-800'}`}>Analytics</button>
        </div>
      </div>

      {activeSubTab === 'list' && (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-slate-50 text-slate-600 font-bold uppercase text-xs">
                <tr>
                  <th className="p-4">Data</th>
                  <th className="p-4">Professor</th>
                  <th className="p-4">Disciplina</th>
                  <th className="p-4 text-center">Média SOLO</th>
                  <th className="p-4 text-center">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {(!stats ? [] : stats.filtered).map(obs => (
                  <tr key={obs.id} className="hover:bg-slate-50 transition-colors">
                    <td className="p-4">{new Date(obs.date).toLocaleDateString()}</td>
                    <td className="p-4 font-medium text-slate-800">{obs.teacher}</td>
                    <td className="p-4">{obs.subject}</td>
                    <td className="p-4 text-center">
                      <span className={`px-2 py-1 rounded-full text-xs font-bold ${parseFloat(obs.stats.average) >= 4 ? 'bg-emerald-100 text-emerald-700' : parseFloat(obs.stats.average) >= 3 ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700'}`}>
                        {obs.stats.average}
                      </span>
                    </td>
                    <td className="p-4 text-center flex items-center justify-center gap-2">
                      <button title="Baixar PDF" onClick={() => generateObservationPDF(obs, obs.stats)} className="p-2 text-slate-600 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-colors"><FileDown className="w-4 h-4" /></button>
                      <button title="Editar" onClick={() => onEdit(obs)} className="p-2 text-slate-600 hover:text-amber-600 hover:bg-amber-50 rounded-full transition-colors"><Edit3 className="w-4 h-4" /></button>
                      <button title="Apagar" onClick={() => handleDelete(obs)} className="p-2 text-slate-600 hover:text-red-600 hover:bg-red-50 rounded-full transition-colors"><Trash2 className="w-4 h-4" /></button>
                    </td>
                  </tr>
                ))}
                {(!stats || stats.filtered.length === 0) && (
                  <tr>
                    <td colSpan="6" className="p-8 text-center text-slate-400">Nenhuma observação encontrada.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeSubTab === 'analytics' && (
        stats ? (
          <div className="space-y-6 animate-in fade-in">
            <div className="bg-white p-4 rounded-xl border border-slate-200 flex items-center gap-4">
              <Filter className="w-5 h-5 text-slate-400" />
              <span className="text-sm font-bold text-slate-600">Filtrar por Professor:</span>
              <select value={selectedTeacher} onChange={e => setSelectedTeacher(e.target.value)} className="p-2 bg-slate-50 border border-slate-200 rounded-lg outline-none text-sm">
                <option value="Todos">Todos os Professores</option>
                {teachers.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                <h3 className="text-sm font-bold text-slate-500 uppercase mb-4">Média Geral</h3>
                <div className="text-4xl font-bold text-slate-800">{stats.avg}</div>
                <p className="text-sm text-slate-400 mt-2">Baseado em {stats.count} observações</p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 md:col-span-2">
                <h3 className="text-sm font-bold text-slate-500 uppercase mb-4">Distribuição por Nível Predominante</h3>
                <div className="space-y-3">
                  {Object.entries(stats.levelCounts).map(([level, count]) => (
                    <div key={level}>
                      <div className="flex justify-between text-xs font-bold text-slate-600 mb-1">
                        <span>{level}</span>
                        <span>{count} ({Math.round(count / stats.count * 100)}%)</span>
                      </div>
                      <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                        <div className="h-full bg-blue-500" style={{ width: `${(count / stats.count) * 100}%` }}></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <h3 className="text-sm font-bold text-slate-500 uppercase mb-6">Desempenho por Critério (Média)</h3>
              <div className="h-64 flex items-end gap-2 justify-between">
                {stats.criteriaResults.map(c => {
                  const height = Math.min((c.avg / 5) * 100, 100);
                  return (
                    <div key={c.key} className="flex-1 h-full flex flex-col items-center justify-end group relative">
                      <div className="w-full bg-blue-100 rounded-t-lg relative transition-all group-hover:bg-blue-200" style={{ height: `${height}%` }}>
                        <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-bold text-slate-600 opacity-0 group-hover:opacity-100 transition-opacity">{c.avg}</span>
                      </div>
                      <span className="text-[10px] text-slate-400 mt-2 text-center leading-tight">{
                        c.key === 'solo2' ? 'Condução' :
                          c.key === 'solo3' ? 'Domínio' :
                            c.key === 'solo4' ? 'Metodologia' :
                              c.key === 'solo5' ? 'Clareza' :
                                c.key === 'solo6' ? 'Engajamento' :
                                  c.key === 'solo7' ? 'Recursos' :
                                    c.key === 'solo8' ? 'Avaliação' :
                                      c.key === 'solo9' ? 'Inclusão' : 'Postura'
                      }</span>
                    </div>
                  )
                })}
              </div>
            </div>

            {selectedTeacher !== 'Todos' && (
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                <h3 className="text-sm font-bold text-slate-500 uppercase mb-6">Evolução do Desempenho (Média SOLO)</h3>
                <div className="h-64 relative">
                  {/* CHART CONTENT */}
                  {(() => {
                    const sortedObs = [...stats.filtered].sort((a, b) => new Date(a.date) - new Date(b.date));
                    if (sortedObs.length < 2) return <div className="h-full flex items-center justify-center text-slate-400 text-sm">Necessário ao menos 2 observações para gerar o gráfico de evolução.</div>;

                    const maxScore = 5;
                    const points = sortedObs.map((obs, i) => {
                      const x = (i / (sortedObs.length - 1)) * 100;
                      const y = 100 - ((parseFloat(obs.stats.average) / maxScore) * 100);
                      return { x, y, val: obs.stats.average, date: obs.date };
                    });

                    const pathD = points.map((p, i) => (i === 0 ? `M ${p.x} ${p.y}` : `L ${p.x} ${p.y}`)).join(' ');

                    return (
                      <div className="absolute inset-0 top-4 bottom-8 left-4 right-4">
                        {/* Grid Lines */}
                        {[0, 1, 2, 3, 4, 5].map(v => (
                          <div key={v} className="absolute w-full border-t border-slate-100" style={{ bottom: `${(v / 5) * 100}%` }}>
                            <span className="absolute -left-6 -top-2 text-[10px] text-slate-300">{v}</span>
                          </div>
                        ))}

                        <svg className="w-full h-full overflow-visible" preserveAspectRatio="none" viewBox="0 0 100 100">
                          <defs>
                            <linearGradient id="gradient" x1="0" x2="0" y1="0" y2="1">
                              <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.5" />
                              <stop offset="100%" stopColor="#3b82f6" stopOpacity="0" />
                            </linearGradient>
                          </defs>
                          <path d={pathD} fill="none" stroke="#3b82f6" strokeWidth="2" vectorEffect="non-scaling-stroke" />
                          <path d={`${pathD} L 100 100 L 0 100 Z`} fill="url(#gradient)" stroke="none" vectorEffect="non-scaling-stroke" opacity="0.2" />
                        </svg>

                        {/* Points */}
                        {points.map((p, i) => (
                          <div key={i} className="absolute w-3 h-3 bg-white border-2 border-blue-500 rounded-full -ml-1.5 -mt-1.5 group cursor-pointer z-10" style={{ left: `${p.x}%`, top: `${p.y}%` }}>
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-slate-800 text-white text-[10px] rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-20">
                              {new Date(p.date).toLocaleDateString()}: {p.val}
                            </div>
                          </div>
                        ))}

                        {/* Date Labels */}
                        <div className="absolute -bottom-6 w-full flex justify-between text-[10px] text-slate-400 font-medium">
                          <span>{new Date(sortedObs[0].date).toLocaleDateString()}</span>
                          <span>{new Date(sortedObs[sortedObs.length - 1].date).toLocaleDateString()}</span>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="p-8 text-center text-slate-400">Dados insuficientes para análise.</div>
        )
      )}

      {viewingObs && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setViewingObs(null)}>
          <div className="bg-white p-6 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <h3 className="font-bold text-xl mb-4 text-slate-800">Detalhes da Observação</h3>
            <div className="space-y-4 text-sm">
              <div className="grid grid-cols-2 gap-4">
                <div><span className="font-bold">Professor:</span> {viewingObs.teacher}</div>
                <div><span className="font-bold">Data:</span> {new Date(viewingObs.date).toLocaleDateString()}</div>
              </div>
              <div className="bg-slate-50 p-4 rounded-lg">
                <h4 className="font-bold mb-2 text-slate-700">Evidências:</h4>
                <p className="whitespace-pre-wrap text-slate-600">{viewingObs.evidence}</p>
              </div>
              <div className="bg-slate-50 p-4 rounded-lg">
                <h4 className="font-bold mb-2 text-slate-700">Sugestões:</h4>
                <p className="whitespace-pre-wrap text-slate-600">{viewingObs.suggestions}</p>
              </div>
            </div>
            <button onClick={() => setViewingObs(null)} className="mt-6 w-full py-2 bg-slate-800 text-white rounded-lg">Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

// --- COMPONENTE: DASHBOARD DO ADMINISTRADOR ---
const AdminDashboard = ({ session, onLogout }) => {
  const [activeTab, setActiveTab] = useState('welcome');
  const [planners, setPlanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [viewingPlan, setViewingPlan] = useState(null); // Para o modal
  const [editingObservation, setEditingObservation] = useState(null); // Estado para edição

  const handleEditObservation = (obs) => {
    setEditingObservation(obs);
    setActiveTab('observation');
  };

  const [filterGrade, setFilterGrade] = useState(SERIES[0]);
  const [filterTrimestre, setFilterTrimestre] = useState(TRIMESTRES[0]);
  const [filterSubjects, setFilterSubjects] = useState([]);
  useEffect(() => {
    setFilterSubjects([]);
  }, [filterGrade]);
  const availableSubjectsForFilter = useMemo(() => {
    return getSubjectsForGrade(filterGrade);
  }, [filterGrade]);
  useEffect(() => {
    if (activeTab === 'settings' || !db) return;
    const fetchAll = async () => {
      setLoading(true);
      try {
        let docs = [];
        const fetchFromCollection = async (collName, labelUnit) => {
          const snapshot = await getDocs(collection(db, 'artifacts', appId, 'public', 'data', collName));
          const unitDocs = [];
          snapshot.forEach((doc) => {
            unitDocs.push({ id: doc.id, ...doc.data(), originUnit: labelUnit });
          });
          return unitDocs;
        };
        if (session.unit === 'Todas') {
          const [itanhangaData, tijucaData] = await Promise.all([
            fetchFromCollection('planners_itanhanga', 'Itanhangá'),
            fetchFromCollection('planners_tijuca', 'Tijuca')
          ]);
          docs = [...itanhangaData, ...tijucaData];
        } else {
          const collName = `planners_${session.unit.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`;
          docs = await fetchFromCollection(collName, session.unit);
        }
        setPlanners(docs);
        setLoading(false);
      } catch (error) {
        console.error("Erro admin:", error);
        setLoading(false);
      }
    };
    fetchAll();
  }, [session.unit, activeTab]);
  const toggleSubject = (subject) => {
    setFilterSubjects(prev =>
      prev.includes(subject)
        ? prev.filter(s => s !== subject)
        : [...prev, subject]
    );
  };
  const exportMasterCSV = () => {
    let csv = "\uFEFF";
    csv += "Unidade;Professor;Email;Disciplina;Série;Trimestre;Semana;Objetivo de Aprendizagem;Checagem de Aprendizagem;Objeto de Conhecimento;Status;Última Atualização\n";
    planners.forEach(plan => {
      const unit = plan.originUnit || plan.unit || "";
      const teacher = plan.teacherName || "";
      const email = plan.email || plan.editorEmail || "";
      const subject = plan.subject || "";
      const grade = plan.grade || "";
      const trimestre = plan.trimestre || "";
      const lastUpdate = plan.lastUpdated ? new Date(plan.lastUpdated).toLocaleDateString() : "";
      if (plan.rows && Array.isArray(plan.rows)) {
        plan.rows.forEach(row => {
          const clean = (text) => `"${(text || '').replace(/"/g, '""')}"`;
          csv += `${unit};${teacher};${email};${subject};${grade};${trimestre};${row.week};${clean(row.objective)};${clean(row.assessment)};${clean(row.knowledgeObject)};${row.status};${lastUpdate}\n`;
        });
      }
    });
    const link = document.createElement("a");
    link.href = encodeURI("data:text/csv;charset=utf-8," + csv);
    link.download = `Mapa_Geral_Planejamento_MOPI_${new Date().toLocaleDateString().replace(/\//g, '-')}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const filteredPlanners = planners.filter(p =>
    (p.teacherName?.toLowerCase().includes(filter.toLowerCase())) ||
    (p.lastEditor?.toLowerCase().includes(filter.toLowerCase())) ||
    (p.subject?.toLowerCase().includes(filter.toLowerCase())) ||
    (p.grade?.toLowerCase().includes(filter.toLowerCase()))
  );
  const stats = useMemo(() => {
    const total = planners.length;
    const teachers = new Set(planners.map(p => p.lastEditor || p.teacherName)).size;
    const completed = planners.reduce((acc, curr) => {
      const exec = curr.rows?.filter(r => r.status === 'Executado').length || 0;
      const totalRows = curr.rows?.length || 1;
      return acc + (exec / totalRows);
    }, 0);
    const avgProgress = total ? Math.round((completed / total) * 100) : 0;
    const subjectStats = {};
    planners.forEach(p => {
      if (!subjectStats[p.subject]) subjectStats[p.subject] = { total: 0, exec: 0 };
      const exec = p.rows?.filter(r => r.status === 'Executado').length || 0;
      const totalRows = p.rows?.length || 1;
      subjectStats[p.subject].total += 1;
      subjectStats[p.subject].exec += (exec / totalRows);
    });
    const unitStats = { 'Itanhangá': { count: 0, prog: 0 }, 'Tijuca': { count: 0, prog: 0 } };
    planners.forEach(p => {
      if (unitStats[p.originUnit]) {
        const exec = p.rows?.filter(r => r.status === 'Executado').length || 0;
        const totalRows = p.rows?.length || 1;
        unitStats[p.originUnit].count += 1;
        unitStats[p.originUnit].prog += (exec / totalRows);
      }
    });
    return { total, teachers, avgProgress, subjectStats, unitStats };
  }, [planners]);
  const coverageStats = useMemo(() => {
    const matrix = {};
    SERIES.forEach(grade => {
      matrix[grade] = {};
      const expectedSubjects = getSubjectsForGrade(grade); // Array of strings
      TRIMESTRES.forEach(tri => {
        const relevantPlanners = planners.filter(p =>
          p.grade === grade &&
          p.trimestre === tri &&
          (p.rows || []).some(r => r.objective && r.objective.trim().length > 0)
        );
        const plannedSubjects = [...new Set(relevantPlanners.map(p => p.subject))];
        const missingSubjects = expectedSubjects.filter(s => !plannedSubjects.includes(s));
        matrix[grade][tri] = {
          plannedCount: plannedSubjects.length,
          totalCount: expectedSubjects.length,
          percentage: expectedSubjects.length ? Math.round((plannedSubjects.length / expectedSubjects.length) * 100) : 0,
          planned: plannedSubjects,
          missing: missingSubjects
        };
      });
    });
    return matrix;
  }, [planners]);
  const recentActivity = useMemo(() => {
    return [...planners]
      .sort((a, b) => new Date(b.lastUpdated || 0) - new Date(a.lastUpdated || 0))
      .slice(0, 5);
  }, [planners]);
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
      {viewingPlan && <ViewPlanModal plan={viewingPlan} onClose={() => setViewingPlan(null)} />}
      <div className={`bg-slate-900 text-white p-6 shadow-md border-b-4 ${session.unit === 'Todas' ? 'border-purple-500' : 'border-emerald-500'}`}>
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-4 w-full lg:w-auto">
            <div className={`p-2 rounded-lg ${session.unit === 'Todas' ? 'bg-purple-600' : 'bg-emerald-600'}`}>
              {session.unit === 'Todas' ? <Building2 className="w-6 h-6" /> : <ShieldCheck className="w-6 h-6" />}
            </div>
            <div>
              <h1 className="text-2xl font-bold">{session.name}</h1>
              <div className="flex gap-4 text-sm text-slate-400">
                <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${session.unit === 'Todas' ? 'bg-purple-900 text-purple-200' : 'bg-emerald-900 text-emerald-200'}`}>
                  {session.unit}
                </span>
              </div>
            </div>
          </div>
          <div className="flex gap-1 bg-slate-800 p-1 rounded-lg w-full lg:w-auto overflow-x-auto">
            <button onClick={() => setActiveTab('welcome')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'welcome' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <Home className="w-4 h-4" /> Início
            </button>
            <button onClick={() => setActiveTab('gradeView')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'gradeView' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <Layers className="w-4 h-4" /> Visão Integrada
            </button>
            <button onClick={() => setActiveTab('dashboard')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'dashboard' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <FileSpreadsheet className="w-4 h-4" /> Lista Geral
            </button>
            <button onClick={() => setActiveTab('analytics')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'analytics' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <BarChart2 className="w-4 h-4" /> Analítico
            </button>
            <button onClick={() => setActiveTab('observation')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'observation' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <Plus className="w-4 h-4" /> Nova Observação
            </button>
            <button onClick={() => setActiveTab('observation_history')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'observation_history' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <Clock className="w-4 h-4" /> Histórico Obs.
            </button>
            <button onClick={() => setActiveTab('teacher_eval')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'teacher_eval' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <ClipboardCheck className="w-4 h-4" /> Avaliação Docente
            </button>
            {/* <button onClick={() => setActiveTab('student_occurrences')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'student_occurrences' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <AlertTriangle className="w-4 h-4" /> Ocorrências
            </button> */}
            {session.role === 'master' && (
              <button onClick={() => setActiveTab('settings')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'settings' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
                <Settings className="w-4 h-4" /> Config
              </button>
            )}
            {session.role === 'master' && (
              <button onClick={() => setActiveTab('school_sync_va_admin')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'school_sync_va_admin' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
                <CalendarRange className="w-4 h-4" /> School Sync VA
              </button>
            )}
            <button onClick={() => setActiveTab('gestao')} className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${activeTab === 'gestao' ? 'bg-slate-700 text-white shadow' : 'text-slate-400 hover:text-white'}`}>
              <Building2 className="w-4 h-4" /> Gestão Escolar
            </button>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={exportMasterCSV}
              className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-medium transition-colors shadow-lg shadow-emerald-900/20"
              title="Baixar planilha completa com todos os dados"
            >
              <FileDown className="w-4 h-4" /> <span className="hidden xl:inline">Mapa Geral (XLS)</span>
            </button>
            <button onClick={onLogout} className="flex items-center gap-2 px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm border border-slate-700 transition-colors">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto w-full p-6 space-y-6">
        {activeTab === 'welcome' && (
          <div className="flex flex-col items-center justify-center p-8 animate-in fade-in zoom-in-95 duration-500">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-slate-800 mb-4">Painel de Gestão Pedagógica</h1>
              <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                Bem-vindo(a), {session.name}. Selecione um módulo abaixo para iniciar suas atividades de acompanhamento e gestão.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl">


              <button
                onClick={() => setActiveTab('gradeView')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <Layers size={100} className="text-indigo-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-indigo-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-indigo-600">
                    <Layers size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-indigo-600 transition-colors">Visão Integrada</h2>
                  <p className="text-slate-500 mb-4 text-sm">Acompanhe o planejamento por série, disciplina e trimestre com filtros avançados.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-indigo-600 group-hover:mr-2 transition-all">
                    Acessar Visão <ChevronRight size={14} />
                  </span>
                </div>
              </button>

              <button
                onClick={() => setActiveTab('dashboard')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <FileSpreadsheet size={100} className="text-blue-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-blue-600">
                    <FileSpreadsheet size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors">Lista Geral</h2>
                  <p className="text-slate-500 mb-4 text-sm">Visualize todos os planejamentos em lista, filtre por professor e verifique status.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-blue-600 group-hover:mr-2 transition-all">
                    Ver Lista <ChevronRight size={14} />
                  </span>
                </div>
              </button>

              <button
                onClick={() => setActiveTab('analytics')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <BarChart2 size={100} className="text-emerald-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-emerald-600">
                    <BarChart2 size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-emerald-600 transition-colors">Painel Analítico</h2>
                  <p className="text-slate-500 mb-4 text-sm">Métricas de adesão, desempenho por área e cobertura curricular das unidades.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-emerald-600 group-hover:mr-2 transition-all">
                    Ver Gráficos <ChevronRight size={14} />
                  </span>
                </div>
              </button>

              <button
                onClick={() => setActiveTab('observation')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <Eye size={100} className="text-purple-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-purple-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-purple-600">
                    <Plus size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-purple-600 transition-colors">Nova Observação</h2>
                  <p className="text-slate-500 mb-4 text-sm">Realize novas observações de aula com suporte de IA para feedback pedagógico.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-purple-600 group-hover:mr-2 transition-all">
                    Iniciar Obs. <ChevronRight size={14} />
                  </span>
                </div>
              </button>

              <button
                onClick={() => setActiveTab('observation_history')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <Clock size={100} className="text-amber-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-amber-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-amber-600">
                    <Clock size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-amber-600 transition-colors">Histórico de OBS.</h2>
                  <p className="text-slate-500 mb-4 text-sm">Consulte o histórico completo de observações realizadas e feedbacks enviados.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-amber-600 group-hover:mr-2 transition-all">
                    Ver Histórico <ChevronRight size={14} />
                  </span>
                </div>
              </button>

              <button
                onClick={() => setActiveTab('teacher_eval')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <ClipboardCheck size={100} className="text-teal-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-teal-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-teal-600">
                    <ClipboardCheck size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-teal-600 transition-colors">Avaliação Docente</h2>
                  <p className="text-slate-500 mb-4 text-sm">Gerencie o ciclo de avaliação de desempenho dos professores.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-teal-600 group-hover:mr-2 transition-all">
                    Acessar <ChevronRight size={14} />
                  </span>
                </div>
              </button>

              {/* <button
                onClick={() => setActiveTab('student_occurrences')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <AlertTriangle size={100} className="text-orange-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-orange-600">
                    <AlertTriangle size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Ocorrências</h2>
                  <p className="text-slate-500 mb-4 text-sm">Gestão disciplinar, registro de ocorrências e elogios dos alunos.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-orange-600 group-hover:mr-2 transition-all">
                    Gerenciar <ChevronRight size={14} />
                  </span>
                </div>
              </button> */}

              {session.role === 'master' && (
                <button
                  onClick={() => setActiveTab('settings')}
                  className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Settings size={100} className="text-gray-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-14 h-14 bg-gray-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-gray-600">
                      <Settings size={28} />
                    </div>
                    <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-gray-600 transition-colors">Configurações</h2>
                    <p className="text-slate-500 mb-4 text-sm">Ajustes globais do sistema, usuários e permissões (Acesso Master).</p>
                    <span className="inline-flex items-center gap-2 text-xs font-bold text-gray-600 group-hover:mr-2 transition-all">
                      Configurar <ChevronRight size={14} />
                    </span>
                  </div>
                </button>
              )}

              <button
                onClick={() => setActiveTab('gestao')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <Building2 size={100} className="text-pink-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-pink-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-pink-600">
                    <Building2 size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-pink-600 transition-colors">Gestão Escolar</h2>
                  <p className="text-slate-500 mb-4 text-sm">Módulo Administrativo: Estratégia, rotinas e gestão de tarefas.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-pink-600 group-hover:mr-2 transition-all">
                    Acessar Módulo <ChevronRight size={14} />
                  </span>
                </div>
              </button>

              <button
                onClick={() => setActiveTab('timetable')}
                className="group relative bg-white p-6 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
              >
                <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <CalendarRange size={100} className="text-orange-600" />
                </div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-orange-600">
                    <CalendarRange size={28} />
                  </div>
                  <h2 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Grade Horária</h2>
                  <p className="text-slate-500 mb-4 text-sm">Visualize a grade horária institucional completa, turmas e professores.</p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-orange-600 group-hover:mr-2 transition-all">
                    Acessar Grade <ChevronRight size={14} />
                  </span>
                </div>
              </button>
            </div>
          </div>
        )}

        {activeTab === 'observation' && <ObservationForm planners={planners} session={session} initialData={editingObservation} />}
        {activeTab === 'observation_history' && <ObservationsView session={session} onEdit={handleEditObservation} />}
        {activeTab === 'teacher_eval' && <TeacherEvaluation db={db} auth={auth} currentUser={session} appId={appId} />}
        {activeTab === 'student_occurrences' && (
          <StudentOccurrences
            db={db}
            currentUser={session}
            appId={appId}
            classes={Object.values(CLASSES_BY_GRADE).flat()}
            trimestres={TRIMESTRES}
          />
        )}
        {activeTab === 'settings' && session.role === 'master' && <SystemSettings />}
        {activeTab === 'timetable' && <NewTimetable />}
        {activeTab === 'gestao' && <GestaoEscolar />}
        {activeTab === 'school_sync_va_admin' && session.role === 'master' && (
          <SchoolSyncVA auth={auth} db={db} session={session} userRole="master" />
        )}
        {activeTab === 'analytics' && (
          <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-indigo-500" /> Comparativo de Unidades
                </h3>
                <div className="space-y-4">
                  {Object.entries(stats.unitStats).map(([uName, data]) => {
                    const avg = data.count ? Math.round((data.prog / data.count) * 100) : 0;
                    return (
                      <div key={uName}>
                        <div className="flex justify-between text-sm mb-1">
                          <span className="font-medium text-slate-700">{uName}</span>
                          <span className="text-slate-500">{data.count} planejamentos ({avg}%)</span>
                        </div>
                        <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                          <div className={`h-full ${uName === 'Tijuca' ? 'bg-orange-500' : 'bg-indigo-500'}`} style={{ width: `${avg}%` }} />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                  <BarChart2 className="w-5 h-5 text-emerald-500" /> Desempenho por Matéria
                </h3>
                <div className="space-y-3 max-h-64 overflow-y-auto pr-2 custom-scrollbar">
                  {Object.entries(stats.subjectStats)
                    .sort(([, a], [, b]) => (b.exec / b.total) - (a.exec / a.total))
                    .map(([sub, data]) => {
                      const avg = Math.round((data.exec / data.total) * 100);
                      return (
                        <div key={sub} className="flex items-center gap-3 text-sm">
                          <div className="w-24 truncate text-slate-600" title={sub}>{sub}</div>
                          <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
                            <div className={`h-full ${avg < 30 ? 'bg-red-400' : avg < 70 ? 'bg-yellow-400' : 'bg-green-400'}`} style={{ width: `${avg}%` }} />
                          </div>
                          <div className="w-8 text-right font-medium text-slate-700">{avg}%</div>
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
            {/* NEW: Cobertura Curricular Matrix */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                <CheckSquare className="w-5 h-5 text-blue-500" /> Panorama de Cobertura Curricular
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left">
                  <thead>
                    <tr className="bg-slate-50 text-slate-500 uppercase text-xs">
                      <th className="p-3 border-b">Série / Ano</th>
                      {TRIMESTRES.map(t => <th key={t} className="p-3 border-b text-center">{t}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {SERIES.map(grade => (
                      <tr key={grade} className="border-b border-slate-100 last:border-0 hover:bg-slate-50 transition-colors">
                        <td className="p-3 font-medium text-slate-700 border-r border-slate-100">{grade}</td>
                        {TRIMESTRES.map(tri => {
                          const stat = coverageStats[grade][tri];
                          let colorClass = 'bg-red-50 text-red-700 ring-1 ring-red-200';
                          if (stat.percentage > 30) colorClass = 'bg-yellow-50 text-yellow-700 ring-1 ring-yellow-200';
                          if (stat.percentage > 70) colorClass = 'bg-green-50 text-green-700 ring-1 ring-green-200';
                          // Tooltip content logic
                          const tooltipText = `Planejado (${stat.plannedCount}):\n${stat.planned.join(', ') || 'Nenhum'}\n\nPendente (${stat.missing.length}):\n${stat.missing.join(', ') || 'Nenhum'}`;
                          return (
                            <td key={tri} className="p-3 text-center">
                              <div
                                title={tooltipText}
                                className={`inline-flex flex-col items-center justify-center p-2 rounded-lg w-full max-w-[120px] mx-auto cursor-help ${colorClass}`}
                              >
                                <span className="font-bold text-lg">{stat.plannedCount}/{stat.totalCount}</span>
                                <span className="text-[10px] uppercase font-bold opacity-80">{stat.percentage}% Completo</span>
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* NEW: Recent Activity */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                <Clock className="w-5 h-5 text-slate-500" /> Últimas Atualizações
              </h3>
              <div className="space-y-2">
                {recentActivity.map((plan) => (
                  <div key={plan.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer" onClick={() => setViewingPlan(plan)}>
                    <div className="flex items-center gap-3">
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs text-white ${plan.originUnit === 'Tijuca' ? 'bg-orange-400' : 'bg-indigo-400'}`}>
                        {(plan.lastEditor || plan.teacherName)?.substring(0, 1)}
                      </div>
                      <div>
                        <div className="text-sm font-bold text-slate-700">{plan.subject} - {plan.grade}</div>
                        <div className="text-xs text-slate-500">Editado por <span className="font-medium text-slate-700">{plan.lastEditor || plan.teacherName}</span></div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-xs font-bold text-slate-600">{new Date(plan.lastUpdated).toLocaleDateString()}</div>
                      <div className="text-[10px] text-slate-400">{new Date(plan.lastUpdated).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {activeTab === 'gradeView' && (
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex flex-col gap-6">
              <div className="flex flex-col md:flex-row gap-4 items-center justify-between border-b border-slate-100 pb-4">
                <div className="flex items-center gap-2 text-slate-700 font-bold text-lg">
                  <Filter className="w-5 h-5 text-blue-600" />
                  Filtros de Visualização
                </div>
                <div className="flex gap-4 w-full md:w-auto">
                  <select
                    value={filterGrade}
                    onChange={(e) => setFilterGrade(e.target.value)}
                    className="p-2 border border-slate-300 rounded-lg text-sm font-medium text-slate-700 outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50 min-w-[150px]"
                  >
                    {SERIES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                  <select
                    value={filterTrimestre}
                    onChange={(e) => setFilterTrimestre(e.target.value)}
                    className="p-2 border border-slate-300 rounded-lg text-sm font-medium text-slate-700 outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50 min-w-[150px]"
                  >
                    {TRIMESTRES.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <h4 className="text-xs font-bold text-slate-400 uppercase mb-3 flex items-center gap-1">
                  <CheckSquare className="w-3 h-3" /> Filtrar Disciplinas (Clique para selecionar)
                </h4>
                <div className="flex flex-wrap gap-2">
                  {availableSubjectsForFilter.map((disc) => {
                    const isSelected = filterSubjects.includes(disc);
                    return (
                      <button
                        key={disc}
                        onClick={() => toggleSubject(disc)}
                        className={`
                          px-3 py-1.5 rounded-full text-xs font-semibold transition-all border
                          ${isSelected
                            ? 'bg-blue-600 text-white border-blue-600 shadow-md shadow-blue-200'
                            : 'bg-white text-slate-600 border-slate-200 hover:border-blue-300 hover:text-blue-600'}
                        `}
                      >
                        {disc}
                      </button>
                    );
                  })}
                  {filterSubjects.length > 0 && (
                    <button
                      onClick={() => setFilterSubjects([])}
                      className="px-3 py-1.5 rounded-full text-xs font-medium text-red-500 hover:bg-red-50 transition-colors ml-2"
                    >
                      Limpar Filtros
                    </button>
                  )}
                </div>
              </div>
            </div>
            {loading ? (
              <div className="p-12 flex justify-center text-slate-400 gap-2">
                <Loader2 className="w-6 h-6 animate-spin" /> Carregando visão integrada...
              </div>
            ) : (
              <GradeOverview
                planners={planners}
                selectedGrade={filterGrade}
                selectedTrimestre={filterTrimestre}
                filterSubjects={filterSubjects}
              />
            )}
          </div>
        )}
        {activeTab === 'dashboard' && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 animate-in fade-in zoom-in duration-300">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 border-l-4 border-l-indigo-500">
                <div className="text-slate-500 text-sm font-medium mb-1">Total de Planejamentos</div>
                <div className="text-3xl font-bold text-indigo-600">{stats.total}</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 border-l-4 border-l-emerald-500">
                <div className="text-slate-500 text-sm font-medium mb-1">Professores Ativos</div>
                <div className="text-3xl font-bold text-emerald-600">{stats.teachers}</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 border-l-4 border-l-blue-500">
                <div className="text-slate-500 text-sm font-medium mb-1">Progresso Médio</div>
                <div className="text-3xl font-bold text-blue-600">{stats.avgProgress}%</div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="p-6 border-b border-slate-100 flex flex-col md:flex-row justify-between items-center gap-4">
                <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                  <FileSpreadsheet className="w-5 h-5 text-slate-400" /> Registros Acadêmicos
                </h2>
                <div className="relative w-full md:w-64">
                  <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
                  <input
                    type="text"
                    placeholder="Filtrar por último editor..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className="w-full pl-9 p-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>
              </div>
              <div className="overflow-x-auto">
                {loading ? (
                  <div className="p-12 flex justify-center text-slate-400 gap-2">
                    <Loader2 className="w-6 h-6 animate-spin" /> Carregando base de dados...
                  </div>
                ) : filteredPlanners.length === 0 ? (
                  <div className="p-12 text-center text-slate-400">
                    Nenhum planejamento encontrado.
                  </div>
                ) : (
                  <table className="w-full text-left text-sm">
                    <thead className="bg-slate-50 text-slate-500 uppercase font-semibold">
                      <tr>
                        <th className="p-4 border-b">Último Editor</th>
                        {session.unit === 'Todas' && <th className="p-4 border-b">Unidade</th>}
                        <th className="p-4 border-b">Disciplina</th>
                        <th className="p-4 border-b">Série/Turma</th>
                        <th className="p-4 border-b">Trimestre</th>
                        <th className="p-4 border-b w-32">Progresso</th>
                        <th className="p-4 border-b text-right">Ação</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {filteredPlanners.map((p) => {
                        const exec = p.rows?.filter(r => r.status === 'Executado').length || 0;
                        const total = p.rows?.length || 1;
                        const prog = Math.round((exec / total) * 100);
                        const editor = p.lastEditor || p.teacherName;
                        return (
                          <tr key={p.id} className="hover:bg-slate-50 transition-colors">
                            <td className="p-4 font-medium text-slate-800">
                              <div className="flex items-center gap-2">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs ${p.originUnit === 'Tijuca' ? 'bg-orange-100 text-orange-600' : 'bg-indigo-100 text-indigo-600'}`}>
                                  {editor?.substring(0, 2).toUpperCase()}
                                </div>
                                <div>
                                  <div className="text-xs text-slate-500">Editor Recente</div>
                                  <div>{editor}</div>
                                </div>
                              </div>
                            </td>
                            {session.unit === 'Todas' && (
                              <td className="p-4">
                                <span className={`px-2 py-1 rounded text-xs font-bold border ${p.originUnit === 'Tijuca' ? 'bg-orange-50 text-orange-700 border-orange-200' : 'bg-indigo-50 text-indigo-700 border-indigo-200'}`}>
                                  {p.originUnit}
                                </span>
                              </td>
                            )}
                            <td className="p-4 text-slate-600">{p.subject}</td>
                            <td className="p-4 text-slate-600">
                              <span className="px-2 py-1 bg-slate-100 rounded text-xs font-semibold">{p.grade}</span>
                              {p.turma && <span className="ml-2 text-xs text-slate-400">({p.turma})</span>}
                            </td>
                            <td className="p-4 text-slate-600 font-medium">{p.trimestre}</td>
                            <td className="p-4">
                              <div className="flex items-center gap-2">
                                <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
                                  <div className="h-full bg-emerald-500" style={{ width: `${prog}%` }}></div>
                                </div>
                                <span className="text-xs font-bold text-slate-600">{prog}%</span>
                              </div>
                            </td>
                            <td className="p-4 text-right">
                              <div className="flex justify-end gap-2">

                                <button
                                  onClick={() => setViewingPlan(p)}
                                  className="flex items-center gap-1 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded text-xs font-semibold transition-colors"
                                  title="Ver Detalhes"
                                >
                                  <Eye className="w-3.5 h-3.5" /> Ver
                                </button>
                                <button
                                  onClick={() => {
                                    let csv = `Unidade: ${p.originUnit}\nEditor: ${editor}\nDisciplina: ${p.subject} - ${p.grade}\nTrimestre: ${p.trimestre}\n\nSemana;Objetivo;Checagem de Aprendizagem;Objeto de Conhecimento;Status\n`;
                                    csv += `\n"Nota Importante: O planejamento é um instrumento dinâmico e flexível. O cronograma e as atividades aqui propostos podem sofrer alterações para melhor atender ao ritmo de aprendizagem da turma ou devido a demandas institucionais e imprevistos."\n\n`;
                                    p.rows.forEach(r => csv += `${r.week};${r.objective};${r.assessment};${r.knowledgeObject};${r.status}\n`);
                                    const link = document.createElement("a");
                                    link.href = encodeURI("data:text/csv;charset=utf-8," + csv);
                                    link.download = `Plan_${p.originUnit}_${p.subject}_${p.grade}_${p.trimestre}.csv`;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                  }}
                                  className="flex items-center gap-1 px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded text-xs font-semibold transition-colors"
                                  title="Baixar Excel"
                                >
                                  <Download className="w-3.5 h-3.5" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
// --- MODAL DE SELEÇÃO MÚLTIPLA ---
const MultiSelectObjectivesModal = ({ rowId, currentObjectives, bnccData, onClose, onSave, grade, subject }) => {
  // Inicialização segura: Garante que 'selected' seja sempre um array
  const [selected, setSelected] = useState(() => {
    if (Array.isArray(currentObjectives)) return currentObjectives;
    if (typeof currentObjectives === 'string' && currentObjectives.trim().length > 0) {
      // Tenta parsear se for JSON
      try {
        const parsed = JSON.parse(currentObjectives);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) { }
      // Se falhar o parse, assume que é texto livre legado e coloca no array
      return [currentObjectives];
    }
    return [];
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [customText, setCustomText] = useState(''); // Novo input para texto personalizado

  const [filterSubject, setFilterSubject] = useState(subject); // Start with current subject

  // Filtra as habilidades baseadas na série e disciplina atuais
  const filteredObjectives = useMemo(() => {
    return bnccData.filter(item => item.serie === grade && item.disciplina === filterSubject);
  }, [bnccData, grade, filterSubject]);

  // Agrupa e filtra por termo de pesquisa
  const groupedAndFilteredObjectives = useMemo(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const grouped = filteredObjectives.reduce((acc, item) => {
      if (item.fullLabel.toLowerCase().includes(lowerSearchTerm) || lowerSearchTerm === '') {
        if (!acc[item.categoria]) acc[item.categoria] = [];
        acc[item.categoria].push(item);
      }
      return acc;
    }, {});
    return grouped;
  }, [filteredObjectives, searchTerm]);

  const toggleObjective = (fullValue) => {
    setSelected(prev =>
      prev.includes(fullValue)
        ? prev.filter(v => v !== fullValue)
        : [...prev, fullValue]
    );
  };

  const addCustomObjective = () => {
    if (customText.trim().length === 0) return;
    const newObj = `Personalizado - ${customText.trim()}`;
    if (!selected.includes(newObj)) {
      setSelected(prev => [...prev, newObj]);
    }
    setCustomText('');
  };

  const removeSelected = (val) => {
    setSelected(prev => prev.filter(v => v !== val));
  };

  const handleSave = () => {
    // Sempre salva como JSON string of array para manter consistência
    onSave(rowId, JSON.stringify(selected));
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl flex flex-col overflow-hidden max-h-[90vh]">

        {/* HEADER */}
        <div className="p-5 border-b border-slate-100 bg-slate-50 flex justify-between items-center">
          <h3 className="text-xl font-bold text-slate-800 flex items-center gap-2">
            <Edit3 className="w-5 h-5 text-blue-600" /> Editar Objetivos (Semana {rowId})
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full text-slate-600 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* ÁREA DE SELEÇÃO E INSERÇÃO */}
        <div className="p-5 flex-shrink-0 flex flex-col gap-4 border-b border-slate-100 bg-white">

          {/* 1. SELECIONADOS */}
          <div>
            <span className="text-xs font-bold text-slate-500 uppercase mb-2 block">
              Objetivos Selecionados ({selected.length})
            </span>
            <div className="flex flex-wrap gap-2 min-h-[40px] p-2 bg-slate-50 border border-slate-200 rounded-lg max-h-[100px] overflow-y-auto">
              {selected.length === 0 && <span className="text-xs text-slate-400 italic">Nenhum objetivo selecionado.</span>}
              {selected.map((obj, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-700 border border-blue-200 group"
                >
                  <span className="truncate max-w-[200px]" title={obj}>{obj.split(' - ')[1] || obj}</span>
                  <button onClick={() => removeSelected(obj)} className="hover:text-red-500 transition-colors">
                    <X className="w-3 h-3" />
                  </button>
                </span>
              ))}
            </div>
          </div>

          {/* 2. ADICIONAR PERSONALIZADO */}
          <div className="flex gap-2">
            <input
              type="text"
              value={customText}
              onChange={(e) => setCustomText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && addCustomObjective()}
              placeholder="Escrever um objetivo personalizado..."
              className="flex-1 p-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
            <button
              onClick={addCustomObjective}
              disabled={!customText.trim()}
              className="px-3 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium text-sm transition-colors flex items-center gap-1 disabled:opacity-50"
            >
              <Plus className="w-4 h-4" /> Adicionar
            </button>
          </div>

          {/* 3. BARRA DE BUSCA BNCC */}
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
            <input
              type="text"
              placeholder="Pesquisar na lista da BNCC abaixo..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-9 p-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
            />
          </div>

          {/* 4. FILTRO DE DISCIPLINA (NOVO) */}
          <div className="mt-4 flex items-center justify-between bg-slate-100 p-3 rounded-lg border border-slate-200">
            <div className="flex items-center gap-2">
              <BookOpen className="w-4 h-4 text-blue-600" />
              <span className="text-xs font-bold text-slate-600 uppercase">Ver objetivos de:</span>
            </div>
            <select
              value={filterSubject}
              onChange={(e) => setFilterSubject(e.target.value)}
              className="bg-white border border-slate-300 text-slate-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-1.5 outline-none font-medium"
            >
              {DISCIPLINAS_MASTER.map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
          </div>
        </div>

        {/* LISTA DE OPÇÕES BNCC */}
        <div className="flex-1 overflow-y-auto px-5 py-2 custom-scrollbar space-y-4 bg-slate-50/50">
          {Object.entries(groupedAndFilteredObjectives).map(([category, items]) => (
            <div key={category} className="pb-2">
              <h4 className="text-xs font-bold text-slate-400 uppercase sticky top-0 bg-slate-50/95 py-2 border-b border-slate-200 z-10">
                {category} ({items.length})
              </h4>
              <div className="space-y-1 mt-2">
                {items.map(item => {
                  const isSelected = selected.includes(item.fullValue);
                  return (
                    <button
                      key={item.fullValue}
                      onClick={() => toggleObjective(item.fullValue)}
                      className={`w-full text-left p-3 rounded-lg border transition-all flex items-start gap-3 group
                            ${isSelected
                          ? 'bg-blue-50 border-blue-400 ring-1 ring-blue-500 shadow-sm'
                          : 'bg-white border-slate-200 hover:border-blue-300 hover:shadow-md'
                        }`}
                    >
                      <div className={`mt-0.5 w-5 h-5 rounded border flex items-center justify-center shrink-0 transition-colors ${isSelected ? 'bg-blue-600 border-blue-600 text-white' : 'border-slate-300 bg-white'}`}>
                        {isSelected && <CheckSquare className="w-3.5 h-3.5" />}
                      </div>
                      <div className="text-sm leading-snug">
                        <span className="font-bold text-slate-700 mr-2 bg-slate-100 px-1.5 py-0.5 rounded text-xs">{item.codigo}</span>
                        <span className={`text-slate-600 ${isSelected ? 'font-medium text-blue-900' : ''}`}>{item.detalhamento}</span>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
          {filteredObjectives.length === 0 && <p className="text-center text-slate-500 py-8 italic">Nenhum objetivo da BNCC encontrado para esta disciplina/série.</p>}
        </div>

        {/* FOOTER */}
        <div className="p-5 border-t border-slate-100 flex justify-between bg-white flex-shrink-0">
          <button onClick={onClose} className="px-5 py-2.5 text-slate-600 hover:bg-slate-100 rounded-lg text-sm font-medium transition-colors">
            Cancelar
          </button>
          <button
            onClick={handleSave}
            className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-bold transition-all shadow-lg shadow-blue-200 transform active:scale-95"
          >
            Salvar Alterações
          </button>
        </div>
      </div>
    </div >
  );
};

// --- COMPONENTE: MODAL DE IMPORTAÇÃO (NOVO) ---
const ImportModal = ({ isOpen, onClose, onImport, activeSubject, currentUnit }) => {
  const [sourceSubject, setSourceSubject] = useState(activeSubject);
  const [sourceClass, setSourceClass] = useState('');
  const [sourceUnit, setSourceUnit] = useState(currentUnit); // Default: mesma unidade
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (!sourceClass) {
      alert("Por favor, selecione a Turma de Origem.");
      return;
    }
    setIsLoading(true);
    await onImport(sourceSubject, sourceClass, sourceUnit);
    setIsLoading(false);
  };

  // Monta lista plana de todas as turmas para o select
  const allTuitionClasses = Object.values(CLASSES_BY_GRADE).flat();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div className="bg-white p-6 rounded-xl shadow-2xl max-w-md w-full border border-slate-100 flex flex-col gap-5">
        <div className="flex items-center gap-3 text-purple-600 border-b border-gray-100 pb-3">
          <Copy className="w-6 h-6" />
          <h3 className="text-xl font-bold text-slate-800">Importar Planejamento</h3>
        </div>

        <p className="text-sm text-slate-600 bg-purple-50 p-3 rounded-lg border border-purple-100">
          Selecione de onde você deseja copiar os dados. <br />
          <b>Atenção:</b> Isso substituirá o planejamento atual.
        </p>

        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-1">Unidade de Origem</label>
            <select
              value={sourceUnit}
              onChange={(e) => setSourceUnit(e.target.value)}
              className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-lg text-sm text-slate-800 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none"
            >
              {UNIDADES.map(u => (
                <option key={u} value={u}>{u}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-700 mb-1">Disciplina de Origem</label>
            <select
              value={sourceSubject}
              onChange={(e) => setSourceSubject(e.target.value)}
              className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-lg text-sm text-slate-800 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none"
            >
              {DISCIPLINAS_MASTER.map(d => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-700 mb-1">Turma de Origem</label>
            <select
              value={sourceClass}
              onChange={(e) => setSourceClass(e.target.value)}
              className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-lg text-sm text-slate-800 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none"
            >
              <option value="">Selecione a turma...</option>
              <option value="Geral">Todas / Geral (Sem turma)</option>
              {allTuitionClasses.map(t => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg text-sm font-bold transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={isLoading}
            className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-bold shadow-lg shadow-purple-200 transform active:scale-95 disabled:opacity-70 flex items-center gap-2"
          >
            {isLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Copy className="w-4 h-4" />}
            Importar Dados
          </button>
        </div>
      </div>
    </div>
  );
};

// --- COMPONENTE: PLANEJADOR DO PROFESSOR (COMPARTILHADO) ---
const ClassPlanner = ({ subject, grade, teacherProfile, onToggleUnit }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTrimestre, setActiveTrimestre] = useState('1º Trimestre');
  const [rowToClear, setRowToClear] = useState(null); // Estado para o modal de confirmação
  const [generatingRowId, setGeneratingRowId] = useState(null);
  const [bnccData, setBnccData] = useState([]); // NOVO: Estado para guardar os dados da BNCC
  const [isMultiSelectOpen, setIsMultiSelectOpen] = useState(false); // NOVO: Controla o modal de seleção
  const [editingRow, setEditingRow] = useState(null); // NOVO: ID da linha sendo editada
  const [activeClass, setActiveClass] = useState(''); // NOVO: Estado da Turma (Ex: 91M, 92M)
  const [isImporting, setIsImporting] = useState(false); // NOVO: Estado de loading da importação
  const [isImportModalOpen, setIsImportModalOpen] = useState(false); // NOVO: Controla modal de importação
  const [data, setData] = useState({
    rows: [],
    trimestre: '1º Trimestre',
    turma: ''
  });
  const availableSubjects = useMemo(() => getSubjectsForGrade(grade), [grade]);
  // Sanitização de nomes de coleção/docs
  const safeSubject = subject.toLowerCase().replace(/[^a-z0-9]/g, '_');
  const safeGrade = grade.toLowerCase().replace(/[^a-z0-9]/g, '_');
  const safeTrimestre = activeTrimestre.replace(/[^0-9]/g, '');
  // Se houver turma definida, ela entra no ID do documento. Se não, usa o ID padrão (legado/geral)
  const safeClass = activeClass ? activeClass.trim().replace(/[^a-z0-9]/gi, '_') : '';
  const docId = safeClass
    ? `${safeSubject}_${safeGrade}_${safeClass}_T${safeTrimestre}`
    : `${safeSubject}_${safeGrade}_T${safeTrimestre}`;
  const unitSuffix = teacherProfile.unit.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
  // Construção do caminho garantindo que não há segmentos vazios/indefinidos
  const collectionPath = ['artifacts', appId, 'public', 'data', `planners_${unitSuffix}`];
  const generateInitialRows = () => Array.from({ length: 12 }, (_, i) => ({
    id: i + 1,
    week: i + 1,
    objective: '', // Agora pode ser JSON string of array ou string simples
    assessment: '',
    knowledgeObject: '',
    startDate: '', // Nova coluna: Data Início
    endDate: '',   // Nova coluna: Data Fim
    material: '',  // Nova coluna: Material Utilizado
    status: 'Planejado'
  }));
  // NOVO: useEffect para carregar o CSV
  useEffect(() => {
    // Simulando carregamento do CSV (já que não temos o arquivo no ambiente)
    const loadData = async () => {
      // Tenta fetch (caso o usuário tenha o arquivo em produção)
      try {
        // ADICIONADO TIMESTAMP PARA EVITAR CACHE
        const response = await fetch(`/dados_bncc.csv?t=${new Date().getTime()}`);
        if (response.ok) {
          const text = await response.text();
          setBnccData(parseCSV(text));
          return;
        }
      } catch (e) {
        // Ignora erro de fetch
      }
      // Fallback para dados embutidos
      setBnccData(parseCSV(BNCC_SAMPLE_DATA));
    };
    loadData();
  }, []);

  // --- IMPORTAR DE OUTRA TURMA (VIA MODAL) ---
  const handleImportClass = (sourceSubject, sourceClass, sourceUnit) => {
    return new Promise(async (resolve) => {
      if (!sourceClass || sourceClass.trim() === '') {
        resolve();
        return;
      }

      // Verifica se está tentando copiar dele mesmo
      if (sourceClass.trim() === activeClass.trim() && sourceSubject === subject && sourceUnit === teacherProfile.unit) {
        alert("A origem e o destino são iguais.");
        resolve();
        return;
      }

      try {
        const sClass = sourceClass === 'Geral' ? '' : sourceClass.trim().replace(/[^a-z0-9]/gi, '_');
        const sSubject = sourceSubject.toLowerCase().replace(/[^a-z0-9]/g, '_');

        // Tenta descobrir a série da turma de origem
        let sourceGrade = grade; // Default: mesma série
        if (sClass) {
          // Procura em CLASSES_BY_GRADE qual chave contém a turma sourceClass
          const foundGrade = Object.keys(CLASSES_BY_GRADE).find(key =>
            CLASSES_BY_GRADE[key].includes(sourceClass)
          );
          if (foundGrade) sourceGrade = foundGrade;
        }

        const sSafeGrade = sourceGrade.toLowerCase().replace(/[^a-z0-9]/g, '_');

        // Constrói ID da origem
        const sourceDocId = sClass
          ? `${sSubject}_${sSafeGrade}_${sClass}_T${safeTrimestre}`
          : `${sSubject}_${sSafeGrade}_T${safeTrimestre}`;

        // Constrói o caminho da coleção com base na unidade de origem
        const sourceUnitSuffix = sourceUnit.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
        const sourceCollectionPath = ['artifacts', appId, 'public', 'data', `planners_${sourceUnitSuffix}`];

        console.log("Tentando importar de:", sourceDocId, "Unidade:", sourceUnit); // DEBUG

        const sourceRef = doc(db, ...sourceCollectionPath, sourceDocId);
        const sourceSnap = await getDoc(sourceRef);

        if (sourceSnap.exists()) {
          const sourceData = sourceSnap.data();
          if (window.confirm(`Encontramos planejamento de:\nUnidade: ${sourceUnit}\nDisciplina: ${sourceSubject}\nTurma: ${sourceClass || 'Geral'} (${sourceGrade})\n\nDeseja SOBRESCREVER o atual?`)) {
            setData(prev => ({
              ...prev,
              rows: sourceData.rows.map(row => ({ ...row }))
            }));
            alert("Dados importados com sucesso!");
            setIsImportModalOpen(false); // Fecha modal
          }
        } else {
          console.warn("Documento não encontrado na unidade", sourceUnit, ":", sourceDocId);
          alert(`Não encontramos planejamento para ${sourceSubject} na turma ${sourceClass} (${sourceGrade}) da unidade ${sourceUnit}.\nID Buscado: ${sourceDocId}`);
        }

      } catch (err) {
        console.error("Erro ao importar:", err);
        alert("Erro ao importar dados. Tente novamente.");
      }
      resolve();
    });
  };
  // Função para carregar dados (MUDANÇA: Agora usa getDoc em vez de onSnapshot para evitar sobrescrita durante edição)
  const fetchData = useCallback(async () => {
    if (!db) return;
    setLoading(true);
    try {
      const docRef = doc(db, ...collectionPath, docId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const remoteData = docSnap.data();
        setData({
          rows: remoteData.rows || generateInitialRows(),
          trimestre: remoteData.trimestre || activeTrimestre,
          turma: remoteData.turma || ''
        });
      } else {
        setData({
          rows: generateInitialRows(),
          trimestre: activeTrimestre,
          turma: ''
        });
      }
    } catch (err) {
      console.error("Erro ao carregar:", err);
    }
    setLoading(false);
  }, [docId, unitSuffix, activeTrimestre]);
  // Carrega dados quando muda a disciplina/série/trimestre
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const saveDataDirectly = async () => {
    setSaving(true);
    try {
      const docRef = doc(db, ...collectionPath, docId);
      const payload = {
        ...JSON.parse(JSON.stringify(data)),
        lastEditor: teacherProfile.name,
        editorEmail: teacherProfile.email,
        subject: subject,
        grade: grade,
        trimestre: activeTrimestre,
        turma: activeClass, // Salva a turma no documento para referência
        originUnit: teacherProfile.unit,
        lastUpdated: new Date().toISOString()
      };
      await setDoc(docRef, payload);
      // Pequeno delay visual para feedback
      setTimeout(() => setSaving(false), 500);
    } catch (err) {
      console.error("Erro ao salvar:", err);
      setSaving(false);
    }
  };
  // Auto-save a cada 30 segundos se houver dados carregados
  useEffect(() => {
    if (!db || loading) return;
    // Tempo aumentado para 30 segundos
    const intervalId = setInterval(() => {
      // Opcional: Verificar se houve mudança (isDirty) antes de salvar para economizar escritas
      saveDataDirectly();
    }, 30000);
    return () => clearInterval(intervalId);
  }, [data, loading, docId]);
  const handleRowChange = (id, field, value) => {
    setData(prev => ({
      ...prev,
      rows: prev.rows.map(row => row.id === id ? { ...row, [field]: value } : row)
    }));
  };
  const addWeek = () => {
    const rows = data.rows;
    const newId = rows.length > 0 ? Math.max(...rows.map(r => r.id)) + 1 : 1;
    const nextWeek = rows.length > 0 ? parseInt(rows[rows.length - 1].week) + 1 : 1;
    setData(prev => ({
      ...prev,
      rows: [...prev.rows, {
        id: newId,
        week: nextWeek,
        objective: '', // string vazia para começar com campo livre/select
        assessment: '',
        knowledgeObject: '',
        startDate: '',
        endDate: '',
        material: '',
        status: 'Planejado'
      }]
    }));
  };
  // Função para efetivar a limpeza
  const executeClearRow = () => {
    if (rowToClear) {
      setData(prev => ({
        ...prev,
        rows: prev.rows.map(row =>
          row.id === rowToClear
            ? { ...row, objective: '', assessment: '', knowledgeObject: '', status: 'Planejado' }
            : row
        )
      }));
      setRowToClear(null); // Fecha o modal
    }
  };
  // --- IA GENERATION LOGIC ---
  const handleAiGeneration = async (rowId, rawObjective) => {
    let objectiveText = rawObjective;
    // Se o objetivo for uma string JSON de array (multi-select), formatamos o prompt
    if (rawObjective.startsWith('[')) {
      try {
        const objectivesArray = JSON.parse(rawObjective);
        if (Array.isArray(objectivesArray) && objectivesArray.length > 0) {
          objectiveText = objectivesArray.map(obj => obj.split(' - ').slice(1).join(' - ')).join('; ');
        }
      } catch (e) {
        // Ignora, objectiveText permanece como rawObjective
      }
    }
    if (!objectiveText || objectiveText.trim().length < 5) {
      alert("Por favor, selecione ou digite um objetivo mais detalhado para gerar sugestões.");
      return;
    }
    setGeneratingRowId(rowId);
    try {
      // 1. Tentar pegar a chave global (Ambiente de Teste)
      let activeKey = globalApiKey;
      // 2. Se não tiver global, tentar pegar do Banco de Dados (Produção)
      if (!activeKey) {
        const configRef = doc(db, 'artifacts', appId, 'public', 'data', 'system_config', 'main');
        const configSnap = await getDoc(configRef);
        if (configSnap.exists() && configSnap.data().gemini_api_key) {
          activeKey = configSnap.data().gemini_api_key;
        }
      }
      if (!activeKey) {
        alert("Erro de Configuração: Nenhuma Chave de API do Gemini foi encontrada.\n\nPor favor, peça à Coordenação para adicionar a chave na aba de Configurações.");
        setGeneratingRowId(null);
        return;
      }
      const promptText = `
        Atue como um especialista pedagógico do MOPI.
        Dado o(s) Objetivo(s) MOPI abaixo para a disciplina de ${subject} e série ${grade}, sugira:
        1. Uma proposta de sequência didática curta e prática para o campo "assessment" (Sequência Didática).
        2. Uma lista de objetos de conhecimento (conteúdos/tópicos) para o campo "knowledgeObject" (Objeto de Conhecimento).
        Objetivo(s) MOPI: "${objectiveText}"
        Responda APENAS com um JSON válido no seguinte formato, sem markdown ou explicações adicionais:
        {
          "assessment": "Texto com as 2 ideias de avaliação...",
          "knowledgeObject": "Texto com os objetos de conhecimento..."
        }
      `;
      const payload = {
        contents: [{ parts: [{ text: promptText }] }],
        generationConfig: {
          responseMimeType: "application/json"
        }
      };
      const response = await fetchWithGeminiResilience(activeKey, payload);
      const result = await response.json();
      if (result.error) {
        throw new Error(result.error.message || "Erro na API");
      }
      const text = result.candidates?.[0]?.content?.parts?.[0]?.text;
      if (text) {
        const json = JSON.parse(text);
        setData(prev => ({
          ...prev,
          rows: prev.rows.map(row =>
            row.id === rowId
              ? {
                ...row,
                assessment: json.assessment || row.assessment,
                knowledgeObject: json.knowledgeObject || row.knowledgeObject
              }
              : row
          )
        }));
      }
    } catch (error) {
      console.error("Erro na geração de IA:", error);
      alert("Não foi possível gerar sugestões. Verifique a conexão ou a validade da Chave API.");
    } finally {
      setGeneratingRowId(null);
    }
  };
  // --- GERAÇÃO DE PDF COM JSPDF E AUTOTABLE ---
  const handleGeneratePDF = async () => {
    setSaving(true);
    try {
      // 1. Carrega as bibliotecas dinamicamente
      await loadPDFLibs();
      // 2. Aguarda um momento para garantir inicialização
      if (!window.jspdf) throw new Error("Falha ao carregar biblioteca PDF");
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF('l', 'mm', 'a4'); // Paisagem
      // --- CONFIGURAÇÃO VISUAL (Estilo Escola Eleva - Upper School) ---
      const headerBgColor = [240, 240, 240]; // Cinza claro (fundo cabeçalho)
      const headerBorderColor = [200, 200, 200];
      const titleColor = [0, 0, 0]; // Preto (Título)
      const labelColor = [0, 0, 0]; // Preto (Rótulos)
      const blueColor = [30, 58, 95]; // Azul Eleva (Navy) para uso na tabela

      // --- HEADER UNIFICADO (Estilo Tabela) ---
      // Logo Box (Esquerda) - 60mm largura
      doc.setFillColor(...headerBgColor);
      doc.setDrawColor(...headerBorderColor);
      doc.rect(14, 10, 60, 25, 'FD');

      // Title Box (Direita) - Restante da largura
      doc.rect(74, 10, 209, 25, 'FD'); // 297 - 14 (margem) - 60 (logo) - 14 (margem) = 209

      // Adicionar Logo na caixa esquerda
      const logoDataUrl = await loadImage(MOPI_LOGO_PDF);
      if (logoDataUrl) {
        // Centralizar logo na caixa de 60x25
        const logoMmWidth = 35;
        const logoMmHeight = 15;
        const logoX = 14 + (60 - logoMmWidth) / 2;
        const logoY = 10 + (25 - logoMmHeight) / 2;
        doc.addImage(logoDataUrl, 'PNG', logoX, logoY, logoMmWidth, logoMmHeight);
      }

      // Adicionar Título na caixa direita
      doc.setFont("helvetica", "bold");
      doc.setFontSize(24);
      doc.setTextColor(...titleColor);
      // Centralizar texto vertical e horizontalmente na caixa direita (x=74, w=209)
      const title = "Upper School Lesson Plan";
      const titleWidth = doc.getTextWidth(title);
      const titleX = 74 + (209 - titleWidth) / 2;
      const titleY = 10 + (25 / 2) + 3; // +3 ajuste visual para baseline
      doc.text(title, titleX, titleY);

      // --- LINHA DE METADADOS (Estilo Tabela Cinza) ---
      doc.setFontSize(10);
      const metaY = 35;
      const rowHeight = 7;

      // Helper para desenhar célula de metadados
      const drawMetaCell = (x, y, w, h, label, value) => {
        doc.setFillColor(230, 230, 230); // Cinza mais escuro para label
        doc.rect(x, y, w, h, 'F'); // Fundo label
        doc.rect(x, y, w, h, 'S'); // Borda

        doc.setFont("helvetica", "bold");
        doc.text(label, x + 2, y + 5);

        // Valor (sem caixa, apenas texto na sequencia se quiser, ou numa caixa ao lado)
        // O estilo da imagem mostra labels na esquerda e campos preenchíveis.
        // Vamos fazer estilo: [Label Box] [Value Box]
      };

      // Linha 1: Disciplina (Full Width)
      // Label
      doc.setFillColor(240, 240, 240);
      doc.rect(14, metaY, 40, rowHeight, 'FD');
      doc.setFont("helvetica", "bold");
      doc.text("Disciplina", 16, metaY + 5);
      // Value
      doc.setFillColor(255, 255, 255); // Branco
      doc.rect(54, metaY, 229, rowHeight, 'FD');
      doc.setFont("helvetica", "normal");
      doc.text(subject || "", 56, metaY + 5);

      // Linha 2: Série | Trimestre
      const y2 = metaY + rowHeight;
      // Série Label
      doc.setFillColor(240, 240, 240);
      doc.rect(14, y2, 40, rowHeight, 'FD');
      doc.setFont("helvetica", "bold");
      doc.text("Série", 16, y2 + 5);
      // Série Value
      doc.setFillColor(255, 255, 255);
      doc.rect(54, y2, 100, rowHeight, 'FD');
      doc.setFont("helvetica", "normal");
      doc.text(grade || "", 56, y2 + 5);

      // Trimestre Label
      doc.setFillColor(240, 240, 240);
      doc.rect(154, y2, 40, rowHeight, 'FD'); // Posição calculada
      doc.setFont("helvetica", "bold");
      doc.text("Trimestre", 156, y2 + 5);
      // Trimestre Value
      doc.setFillColor(255, 255, 255);
      doc.rect(194, y2, 89, rowHeight, 'FD');
      doc.setFont("helvetica", "normal");
      doc.text(activeTrimestre || "", 196, y2 + 5);

      // Linha 3: Professor
      const y3 = y2 + rowHeight;
      // Professor Label
      doc.setFillColor(240, 240, 240);
      doc.rect(14, y3, 40, rowHeight, 'FD');
      doc.setFont("helvetica", "bold");
      doc.text("Professor (a)", 16, y3 + 5);
      // Professor Value
      doc.setFillColor(255, 255, 255);
      doc.rect(54, y3, 229, rowHeight, 'FD');
      doc.setFont("helvetica", "normal");
      doc.text(teacherProfile.name || "", 56, y3 + 5);
      // --- TABELA DE CONTEÚDO ---
      // Reduzindo a fonte do cabeçalho da tabela para evitar cortes
      const tableColumn = ["Semana", "Objetivo de Aprendizagem", "Sequência Didática", "Objeto de Conhecimento", "Material Utilizado", "Status"];
      const formatShortDate = (isoDate) => {
        if (!isoDate) return '';
        const [y, m, d] = isoDate.split('-');
        return `${d}/${m}`;
      };

      const tableRows = data.rows.map(row => {
        let objectiveText = row.objective;
        try {
          const parsed = JSON.parse(row.objective);
          if (Array.isArray(parsed) && parsed.length > 0) {
            // Formata os objetivos como lista numerada para o PDF
            objectiveText = parsed.map((obj, i) => `${obj.split(' - ')[0]}: ${obj.split(' - ').slice(1).join(' - ')}`).join('\n');
          }
        } catch (e) {
          // Se falhar, é texto livre.
        }

        // Formata o texto da primeira coluna (Semana + Datas)
        let weekText = `${row.week}`;
        if (row.startDate && row.endDate) {
          weekText += `\n${formatShortDate(row.startDate)} a ${formatShortDate(row.endDate)}`;
        }

        return [
          weekText,
          objectiveText,
          row.assessment,
          row.knowledgeObject,
          row.material || '',
          row.status
        ];
      });

      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 70,
        theme: 'grid',
        headStyles: {
          fillColor: blueColor,
          textColor: 255,
          fontStyle: 'bold',
          fontSize: 8 // Fonte do cabeçalho da tabela reduzida
        },
        styles: {
          fontSize: 7.5, // Fonte do corpo da tabela reduzida
          cellPadding: 3,
          valign: 'middle', // Centraliza verticalmente para ficar melhor com o campo de data
          overflow: 'linebreak',
          lineColor: [200, 200, 200]
        },
        columnStyles: {
          0: { cellWidth: 15, halign: 'center', fontStyle: 'bold' }, // Data
          1: { cellWidth: 80 }, // Objetivo 
          2: { cellWidth: 60 }, // Checagem
          3: { cellWidth: 60 }, // Objeto
          4: { cellWidth: 40 }, // Material
          5: { cellWidth: 20, halign: 'center' } // Status
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        }
      });
      // --- RODAPÉ ---
      const finalY = doc.lastAutoTable.finalY || 200;
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(`Gerado eletronicamente em ${new Date().toLocaleDateString()} - Unidade ${teacherProfile.unit}`, 14, finalY + 10);
      doc.text('"O planejamento é um instrumento dinâmico e flexível. O cronograma e as atividades aqui propostos podem sofrer alterações."', 14, finalY + 15);
      // 3. Salva o arquivo
      doc.save(`Planejamento_${subject}_${grade}_${activeTrimestre}.pdf`);
    } catch (err) {
      console.error("Erro PDF:", err);
      alert("Não foi possível gerar o PDF. Verifique sua conexão e tente novamente.");
    } finally {
      setSaving(false);
    }
  };
  const exportToCSV = () => {
    let csv = "data:text/csv;charset=utf-8,";
    csv += `Unidade: ${teacherProfile.unit}\nEmail Editor: ${teacherProfile.email}\nDisciplina: ${subject}\nSérie: ${grade}\nTrimestre: ${activeTrimestre}\nTurma: ${data.turma || '-'}\n\n`;
    csv += `\n"Nota Importante: O planejamento é um instrumento dinâmico e flexível. O cronograma e as atividades aqui propostos podem sofrer alterações para melhor atender ao ritmo de aprendizagem da turma ou devido a demandas institucionais e imprevistos."\n\n`;
    csv += "Semana;Objetivo;Sequência Didática;Objeto de Conhecimento;Status\n";
    data.rows.forEach(r => {
      const clean = t => {
        let content = t || '';
        if (content.startsWith('[')) {
          try {
            // Se for array JSON, formata em uma string limpa para o CSV
            const parsed = JSON.parse(content);
            content = Array.isArray(parsed) ? parsed.map(obj => obj.split(' - ')[1]).join(' | ') : content;
          } catch (e) {
            // Ignora se não for JSON válido
          }
        }
        return `"${content.replace(/"/g, '""')}"`;
      };
      csv += `${r.week};${clean(r.objective)};${clean(r.assessment)};${clean(r.knowledgeObject)};${r.status}\n`;
    });
    const link = document.createElement("a");
    link.href = encodeURI(csv);
    link.download = `plan_${teacherProfile.unit}_${subject}_${grade}_${activeTrimestre.replace(' ', '')}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // --- GERAÇÃO DE PDF DO ALUNO (NOVO - REFINE UI - FIXED) ---
  const handleGenerateStudentPDF = async () => {
    setSaving(true);
    try {
      await loadPDFLibs();
      if (!window.jspdf) throw new Error("Falha ao carregar biblioteca PDF");
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF('p', 'mm', 'a4'); // Retrato

      // --- PALETA DE CORES (Baseada na ref.) ---
      const colors = {
        bg: [255, 255, 255],       // Fundo da página (White)
        cardBg: [255, 255, 255],   // Fundo do Card (White)
        cardBorder: [149, 182, 223], // Borda suave (Sky Blue)
        brand: [30, 58, 95],     // Azul MOPI (Navy)
        textDark: [30, 58, 95],    // Navy
        textLight: [96, 165, 250],// Pastel Blue
        inputBg: [248, 250, 252],  // Fundo do "Input" (Slate-50)
        inputBorder: [149, 182, 223] // Sky Blue
      };

      // Fundo Global da Página
      doc.setFillColor(...colors.bg);
      doc.rect(0, 0, 210, 297, 'F');

      // Helper para agregar valores
      const aggregate = (field) => {
        const values = new Set();
        data.rows.forEach(r => {
          if (!r[field]) return;
          if (r[field].startsWith('[')) {
            try {
              const parsed = JSON.parse(r[field]);
              if (Array.isArray(parsed)) {
                parsed.forEach(p => values.add(p.split(' - ').slice(1).join(' - ')));
                return;
              }
            } catch (e) { }
          }
          if (r[field].trim()) values.add(r[field].trim());
        });
        return Array.from(values);
      };

      const objectives = aggregate('objective');
      const objects = aggregate('knowledgeObject');
      const assessments = aggregate('assessment');
      const materials = aggregate('material');

      // --- HEADER DO DOCUMENTO (Estilo Unificado Upper School) ---
      // Replicando o estilo do Teacher PDF mas adaptado para retrato (A4 Portrait = 210mm width)
      const headerBgColor = [240, 240, 240];
      const headerBorderColor = [200, 200, 200];
      const titleColor = [0, 0, 0];

      // Page Margins
      const margin = 10;
      const contentWidth = 210 - (margin * 2);

      // Logo Box (Esquerda) - 50mm largura
      doc.setFillColor(...headerBgColor);
      doc.setDrawColor(...headerBorderColor);
      doc.rect(margin, 10, 50, 25, 'FD');

      // Title Box (Direita) - Restante
      const titleBoxWidth = contentWidth - 50;
      doc.rect(margin + 50, 10, titleBoxWidth, 25, 'FD');

      // Logo
      const logoDataUrl = await loadImage(MOPI_LOGO_PDF);
      if (logoDataUrl) {
        const logoMmWidth = 30;
        const logoMmHeight = 13;
        const logoX = margin + (50 - logoMmWidth) / 2;
        const logoY = 10 + (25 - logoMmHeight) / 2;
        doc.addImage(logoDataUrl, 'PNG', logoX, logoY, logoMmWidth, logoMmHeight);
      }

      // Title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(...titleColor);
      const title = "Upper School Lesson Plan";
      const titleW = doc.getTextWidth(title);
      const titleX = (margin + 50) + (titleBoxWidth - titleW) / 2;
      doc.text(title, titleX, 26); // Aprox middle vertically

      // Metadata Table (Simplificada para Aluno)
      doc.setFontSize(9);
      const metaY = 35;
      const rowHeight = 6;

      // Linha 1: Disciplina
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, metaY, 30, rowHeight, 'FD');
      doc.text("Disciplina", margin + 2, metaY + 4);
      doc.setFillColor(255, 255, 255);
      doc.rect(margin + 30, metaY, contentWidth - 30, rowHeight, 'FD');
      doc.setFont("helvetica", "normal");
      doc.text(subject, margin + 32, metaY + 4);

      // Linha 2: Professor
      doc.setFont("helvetica", "bold");
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, metaY + rowHeight, 30, rowHeight, 'FD');
      doc.text("Professor(a)", margin + 2, metaY + rowHeight + 4);
      doc.setFillColor(255, 255, 255);
      doc.rect(margin + 30, metaY + rowHeight, contentWidth - 30, rowHeight, 'FD');
      doc.setFont("helvetica", "normal");
      doc.text(teacherProfile.name, margin + 32, metaY + rowHeight + 4);

      // --- CONTEÚDO SÍNTESE (Tabela Simples) ---
      const tableColumn = ["Semana", "Objetivos de Aprendizagem", "Atividades / Avaliações"];
      const tableRows = data.rows.map(row => {
        // Formatação Objetivos
        let objectiveText = row.objective || '-';
        try {
          const parsed = JSON.parse(row.objective);
          if (Array.isArray(parsed)) objectiveText = parsed.map(p => p.split(' - ')[1] || p).join('\n');
        } catch (e) { }

        return [
          row.week,
          objectiveText,
          row.assessment || '-'
        ];
      });

      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: metaY + (rowHeight * 2) + 5,
        theme: 'grid',
        headStyles: {
          fillColor: [50, 50, 50], // Cinza escuro/Preto suave
          textColor: 255,
          fontStyle: 'bold',
          fontSize: 10,
          halign: 'center'
        },
        styles: {
          fontSize: 9,
          cellPadding: 3,
          valign: 'top',
          overflow: 'linebreak'
        },
        columnStyles: {
          0: { cellWidth: 20, halign: 'center', fontStyle: 'bold' }, // Semana
          1: { cellWidth: 'auto' }, // Objetivos (Auto expand)
          2: { cellWidth: 50 }, // Avaliações
        }
      });

      const finalY = doc.lastAutoTable.finalY || 200;
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(`Síntese gerada eletronicamente para o aluno em ${new Date().toLocaleDateString()}`, margin, finalY + 10);

      doc.save(`Planejamento_Aluno_${subject}_${grade}.pdf`);

    } catch (err) {
      console.error("Erro PDF Aluno:", err);
      alert("Não foi possível gerar o PDF do aluno.");
    } finally {
      setSaving(false);
    }
  };

  const getStatusColor = (s) => {
    if (s === 'Executado') return 'bg-emerald-100 text-emerald-800 border-emerald-200';
    if (s === 'Atrasado') return 'bg-red-100 text-red-800 border-red-200';
    if (s === 'Adiado') return 'bg-amber-100 text-amber-800 border-amber-200';
    return 'bg-gray-50 text-gray-600 border-gray-200';
  };
  if (loading) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-slate-400 gap-3">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
        <span className="text-sm font-medium">Carregando {activeTrimestre}...</span>
      </div>
    );
  }
  // Filtra as habilidades baseadas na série e disciplina atuais usando o ESTADO bnccData
  const filteredObjectives = bnccData.filter(item => item.serie === grade && item.disciplina === subject);
  // Agrupa por categoria para exibir no <select>
  const groupedObjectives = filteredObjectives.reduce((acc, item) => {
    if (!acc[item.categoria]) acc[item.categoria] = [];
    acc[item.categoria].push(item);
    return acc;
  }, {});
  const hasObjectives = filteredObjectives.length > 0;
  const executed = data.rows.filter(r => r.status === 'Executado').length;
  const progress = data.rows.length ? Math.round((executed / data.rows.length) * 100) : 0;
  // Função para obter os objetivos selecionados na linha atual, se forem JSON
  const getCurrentObjectivesArray = (rowObjective) => {
    try {
      // Se a string for um array JSON válido, retorna o array
      const parsed = JSON.parse(rowObjective);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      // Se não for JSON, ou se for uma string vazia, retorna um array vazio.
      // O modal usará o texto não-JSON para preencher o campo livre.
      return [];
    }
  };
  return (
    <div className="flex flex-col h-full bg-white">
      {isMultiSelectOpen && (
        <MultiSelectObjectivesModal
          rowId={editingRow.id}
          // Passa a string completa do objetivo (seja JSON ou texto livre)
          currentObjectives={editingRow.objective.startsWith('[') ? getCurrentObjectivesArray(editingRow.objective) : editingRow.objective}
          bnccData={bnccData}
          grade={grade}
          subject={subject}
          onClose={() => {
            setIsMultiSelectOpen(false);
            setEditingRow(null);
          }}
          onSave={(id, newObjectiveValue) => handleRowChange(id, 'objective', newObjectiveValue)}
        />
      )}
      <div className="p-4 border-b border-gray-100 bg-white sticky top-0 z-10">
        <div className="flex flex-col xl:flex-row gap-4 justify-between items-start xl:items-center mb-4">
          <div className="flex gap-4 w-full xl:w-auto">
            <div className="flex-1 min-w-[180px]">
              <label className="text-xs font-bold text-slate-400 uppercase flex items-center gap-1 mb-1">
                <Calendar className="w-3 h-3" /> Período Letivo
              </label>
              <select
                value={activeTrimestre}
                onChange={(e) => setActiveTrimestre(e.target.value)}
                className="w-full p-2 bg-slate-50 border border-slate-200 rounded text-sm font-bold text-blue-700 focus:border-blue-500 outline-none cursor-pointer hover:bg-blue-50 transition-colors"
              >
                {TRIMESTRES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="flex-1 min-w-[120px]">
              <label className="text-xs font-bold text-slate-400 uppercase flex items-center gap-1 mb-1">
                <Users className="w-3 h-3" /> Turma
              </label>
              <select
                value={activeClass}
                onChange={(e) => setActiveClass(e.target.value)}
                className="w-full p-2 bg-slate-50 border border-slate-200 rounded text-sm font-bold text-slate-700 focus:border-blue-500 outline-none focus:bg-white transition-colors cursor-pointer"
              >
                <option value="">Todas / Geral</option>
                {CLASSES_BY_GRADE[grade]?.map(turma => (
                  <option key={turma} value={turma}>{turma}</option>
                ))}
              </select>
            </div>
            <div className="flex-1 min-w-[200px]">
              <div className="flex flex-col">
                <span className="text-xs font-bold text-slate-400 uppercase mb-1 flex items-center gap-1">
                  <Building2 className="w-3 h-3" /> Unidade
                </span>
                <div className="flex items-center gap-2">
                  <div className="p-2 bg-slate-100 rounded text-sm text-slate-700 font-semibold border border-slate-200">
                    {teacherProfile.unit}
                  </div>
                  <button
                    onClick={onToggleUnit}
                    className="p-2 bg-white border border-slate-200 hover:border-blue-300 hover:bg-blue-50 text-slate-500 hover:text-blue-600 rounded-lg transition-all"
                    title="Alternar Unidade (Itanhangá <-> Tijuca)"
                  >
                    <ArrowLeftRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 self-end xl:self-auto">
            <button
              onClick={fetchData}
              className="flex items-center gap-2 px-3 py-2 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
              title="Recarregar dados do servidor"
            >
              <Loader2 className="w-4 h-4" />
            </button>
            <button
              onClick={() => setIsImportModalOpen(true)}
              className="flex items-center gap-2 px-3 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-medium transition-colors shadow-sm disabled:opacity-50"
              title="Copiar planejamento de outra turma"
            >
              <Copy className="w-4 h-4" />
              <span className="hidden sm:inline">Importar</span>
            </button>
            <button
              onClick={saveDataDirectly}
              disabled={saving}
              className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-medium transition-all shadow-sm shadow-emerald-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
              <span className="hidden sm:inline">Salvar Agora</span>
            </button>
            <button
              onClick={handleGeneratePDF}
              disabled={saving}
              className="flex items-center gap-2 px-3 py-2 bg-slate-700 hover:bg-slate-800 text-white rounded-lg text-sm font-medium transition-colors shadow-sm disabled:opacity-50"
              title="Baixar PDF"
            >
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
              <span className="hidden sm:inline">PDF</span>
            </button>
            <button
              onClick={handleGenerateStudentPDF}
              disabled={saving}
              className="flex items-center gap-2 px-3 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-medium transition-colors shadow-sm disabled:opacity-50"
              title="Baixar PDF para Alunos"
            >
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
              <span className="hidden sm:inline">PDF Aluno</span>
            </button>
            <button onClick={exportToCSV} className="flex items-center gap-2 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors shadow-sm shadow-blue-200">
              <Download className="w-4 h-4" /> <span className="hidden sm:inline">Excel</span>
            </button>
            <button
              onClick={async () => {
                if (window.confirm(`Limpar todo o planejamento do ${activeTrimestre}?`)) {
                  const newData = { rows: generateInitialRows(), trimestre: activeTrimestre, turma: '' };
                  setData(newData);
                }
              }}
              className="flex items-center gap-2 px-3 py-2 border border-slate-200 hover:bg-red-50 hover:border-red-200 hover:text-red-600 text-slate-600 rounded-lg text-sm font-medium transition-colors"
              title="Limpar planejamento"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
        <div className="h-1 w-full bg-slate-100 rounded-full overflow-hidden flex">
          <div className="h-full bg-emerald-500 transition-all duration-500" style={{ width: `${progress}%` }} />
        </div>
      </div>
      <div className="flex-1 overflow-auto p-4 bg-slate-50/50">
        <ImportModal
          isOpen={isImportModalOpen}
          onClose={() => setIsImportModalOpen(false)}
          onImport={handleImportClass}
          activeSubject={subject}
          currentUnit={teacherProfile.unit}
        />
        {/* MODAL DE CONFIRMAÇÃO DE LIMPEZA */}
        {rowToClear && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
            <div className="bg-white p-6 rounded-xl shadow-2xl max-w-sm w-full border border-slate-100">
              <div className="flex items-center gap-3 text-amber-600 mb-3">
                <AlertTriangle className="w-6 h-6" />
                <h3 className="text-lg font-bold text-slate-800">Limpar Semana?</h3>
              </div>
              <p className="text-sm text-slate-600 mb-6 leading-relaxed">
                Você tem certeza que deseja limpar o conteúdo desta semana?<br />
                <span className="font-bold text-slate-800">A linha será mantida</span>, apenas os textos serão apagados.
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setRowToClear(null)}
                  className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg text-sm font-medium transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={executeClearRow}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-bold transition-colors shadow-sm"
                >
                  Sim, Limpar
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="bg-white shadow-sm border border-slate-200 rounded-lg overflow-hidden min-w-[800px]">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="bg-slate-50 text-slate-500 font-semibold border-b border-slate-200">
                <th className="p-3 w-16 text-center">Sem.</th>
                <th className="p-3 w-32 text-center">Datas</th>
                <th className="p-3 w-1/3">Objetivo de Aprendizagem</th>
                <th className="p-3 w-1/4">Sequência Didática</th>
                <th className="p-3 w-1/4">Objeto de Conhecimento</th>
                <th className="p-3 w-48">Material Utilizado</th>
                <th className="p-3 w-32">Status</th>
                <th className="p-3 w-10"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {data.rows.map(row => {
                const objectivesArray = getCurrentObjectivesArray(row.objective);
                const isMultiSelection = objectivesArray.length > 0;
                // O campo de objective não deve mais ser uma textarea diretamente, mas sim um componente que dispara o modal
                const handleSelectClick = () => {
                  setEditingRow(row);
                  setIsMultiSelectOpen(true);
                };
                let cellContent;
                if (isMultiSelection) {
                  cellContent = (
                    <div className="flex flex-wrap gap-1 w-full p-0.5">
                      {objectivesArray.map(obj => (
                        <span key={obj} className="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700 border border-blue-200">
                          {obj.split(' - ')[0]}
                        </span>
                      ))}
                      <Edit3 className="w-3 h-3 text-slate-400 shrink-0 ml-1 mt-0.5" />
                    </div>
                  );
                } else if (row.objective && row.objective.trim().length > 0) {
                  // Texto livre
                  cellContent = (
                    <div className="text-sm text-slate-700 p-0.5 leading-tight flex justify-between items-start">
                      <span className="max-w-[90%] whitespace-pre-wrap">{row.objective}</span>
                      <Edit3 className="w-3 h-3 text-slate-400 shrink-0" />
                    </div>
                  );
                } else {
                  // Vazio - Call to action
                  cellContent = (
                    <span className="text-sm text-slate-500 italic p-0.5">Clique para selecionar/digitar...</span>
                  );
                }
                return (
                  <tr key={row.id} className="group hover:bg-blue-50/30 transition-colors">
                    <td className="p-2 border-r border-slate-50">
                      <input
                        type="number" value={row.week}
                        onChange={(e) => handleRowChange(row.id, 'week', e.target.value)}
                        className="w-full text-center font-bold text-slate-600 bg-transparent outline-none focus:text-blue-600"
                      />
                    </td>
                    <td className="p-2 border-r border-slate-50 flex flex-col gap-1 justify-center">
                      <input
                        type="date"
                        value={row.startDate || ''}
                        onChange={(e) => handleRowChange(row.id, 'startDate', e.target.value)}
                        className="w-full text-[10px] text-slate-500 bg-transparent outline-none focus:text-blue-600 border-b border-transparent focus:border-blue-200"
                        title="Data Início"
                      />
                      <input
                        type="date"
                        value={row.endDate || ''}
                        onChange={(e) => handleRowChange(row.id, 'endDate', e.target.value)}
                        className="w-full text-[10px] text-slate-500 bg-transparent outline-none focus:text-blue-600 border-b border-transparent focus:border-blue-200"
                        title="Data Fim"
                      />
                    </td>
                    <td
                      className="p-2 border-r border-slate-50 relative group/cell cursor-pointer"
                      onClick={handleSelectClick}
                    >
                      <div className="w-full min-h-[50px] flex items-center">
                        {cellContent}
                      </div>
                      <button
                        onClick={(e) => { e.stopPropagation(); handleAiGeneration(row.id, row.objective); }}
                        disabled={generatingRowId === row.id || (!row.objective || row.objective.trim().length === 0)}
                        className={`absolute bottom-2 right-2 p-1.5 rounded-full shadow-sm border border-purple-200 bg-white text-purple-600 hover:bg-purple-50 transition-all 
                                ${generatingRowId === row.id ? 'animate-pulse opacity-100' : 'opacity-0 group-hover/cell:opacity-100'}
                            `}
                        title="Gerar sugestões com IA"
                      >
                        {generatingRowId === row.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
                      </button>
                    </td>
                    <td className="p-2 border-r border-slate-50">
                      <textarea
                        value={row.assessment}
                        onChange={(e) => handleRowChange(row.id, 'assessment', e.target.value)}
                        placeholder="Descreva a sequência..."
                        className="w-full min-h-[50px] bg-transparent resize-none outline-none focus:bg-white focus:ring-1 focus:ring-blue-200 rounded p-1 transition-all"
                        spellCheck={true}
                        lang="pt-BR"
                      />
                    </td>
                    <td className="p-2 border-r border-slate-50">
                      <textarea
                        value={row.knowledgeObject}
                        onChange={(e) => handleRowChange(row.id, 'knowledgeObject', e.target.value)}
                        placeholder="Objeto de conhecimento..."
                        className="w-full min-h-[50px] bg-transparent resize-none outline-none focus:bg-white focus:ring-1 focus:ring-blue-200 rounded p-1 transition-all"
                        spellCheck={true}
                        lang="pt-BR"
                      />
                    </td>
                    <td className="p-2 border-r border-slate-50">
                      <textarea
                        value={row.material || ''}
                        onChange={(e) => handleRowChange(row.id, 'material', e.target.value)}
                        placeholder="Páginas, Capítulos..."
                        className="w-full min-h-[50px] bg-transparent resize-none outline-none focus:bg-white focus:ring-1 focus:ring-blue-200 rounded p-1 transition-all"
                        spellCheck={true}
                        lang="pt-BR"
                      />
                    </td>
                    <td className="p-2 border-r border-slate-50">
                      <select
                        value={row.status}
                        onChange={(e) => handleRowChange(row.id, 'status', e.target.value)}
                        className={`w-full p-1.5 text-xs font-medium rounded border cursor-pointer outline-none ${getStatusColor(row.status)}`}
                      >
                        <option value="Planejado">Planejado</option>
                        <option value="Executado">Executado</option>
                        <option value="Atrasado">Atrasado</option>
                        <option value="Adiado">Adiado</option>
                      </select>
                    </td>
                    <td className="p-2 text-center">
                      <button
                        onClick={() => setRowToClear(row.id)}
                        className="text-slate-400 hover:text-red-500 hover:bg-red-50 rounded p-1.5 transition-all"
                        title="Limpar conteúdo da semana"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <button onClick={addWeek} className="w-full py-3 text-center text-slate-500 hover:bg-slate-50 hover:text-blue-600 text-sm font-medium transition-colors border-t border-slate-100 flex items-center justify-center gap-2">
            <Plus className="w-4 h-4" /> Adicionar Semana
          </button>
        </div>
      </div>
    </div>
  );
}
// --- COMPONENTE: APP PRINCIPAL ---
export default function App() {
  const [session, setSession] = useState(() => {
    const saved = localStorage.getItem('mopi_planner_session');
    return saved ? JSON.parse(saved) : null;
  });
  const [activeSubject, setActiveSubject] = useState(DISCIPLINAS_MASTER[0]);
  const [activeGrade, setActiveGrade] = useState(SERIES[0]);
  const [teacherViewMode, setTeacherViewMode] = useState('welcome'); // 'welcome' | 'planner' | 'occurrences' | 'study_guide'
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAuthReady, setIsAuthReady] = useState(false);
  const [geminiApiKey, setGeminiApiKey] = useState(apiKey);

  // Fetch API Key from system config
  useEffect(() => {
    const fetchKey = async () => {
      try {
        const configRef = doc(db, 'artifacts', appId, 'public', 'data', 'system_config', 'main');
        const snap = await getDoc(configRef);
        if (snap.exists() && snap.data().gemini_api_key) {
          setGeminiApiKey(snap.data().gemini_api_key);
        }
      } catch (e) { console.error("Erro key app:", e); }
    };
    if (db) fetchKey();
  }, []);
  useEffect(() => {
    // PROTEÇÃO: Se 'auth' não existir (falha de config), não tente autenticar
    if (!auth) return;
    const initAuth = async () => {
      try {
        if (typeof __initial_auth_token !== 'undefined' && __initial_auth_token) {
          await signInWithCustomToken(auth, __initial_auth_token);
        } else if (!auth.currentUser) {
          // Apenas entra anonimamente se não houver um usuário (Google ou Token) já logado
          await signInAnonymously(auth);
        }
      } catch (e) {
        console.warn("Autenticação inicial falhou:", e);
      }
    };
    initAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) setIsAuthReady(true);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const available = getSubjectsForGrade(activeGrade);
    if (!available.includes(activeSubject)) {
      setActiveSubject(available[0]);
    }
  }, [activeGrade, activeSubject]);

  const handleLogin = (newSession) => {
    localStorage.setItem('mopi_planner_session', JSON.stringify(newSession));
    setSession(newSession);
  };

  const handleLogout = () => {
    localStorage.removeItem('mopi_planner_session');
    setSession(null);
  };

  useEffect(() => {
    if (session && session.unit !== 'Barra da Tijuca') {
      setSession(prev => ({ ...prev, unit: 'Barra da Tijuca' }));
    }
  }, [session]);

  if (firebaseInitError) {
    return (
      <div className="flex h-screen items-center justify-center bg-red-50 p-4 text-center font-sans">
        <div className="max-w-md bg-white p-8 rounded-xl shadow-lg border border-red-100">
          <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-slate-800 mb-2">Erro de Inicialização</h2>
          <p className="text-slate-600 mb-4 text-sm leading-relaxed">{firebaseInitError}</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <LoginScreen onLogin={handleLogin} isAuthReady={isAuthReady} />;
  }

  if (session.role === 'admin' || session.role === 'master') {
    return <AdminDashboard session={session} onLogout={handleLogout} />;
  }

  const currentGradeSubjects = getSubjectsForGrade(activeGrade);

  return (
    <div className="flex h-screen bg-gray-100 font-sans overflow-hidden print:h-auto print:overflow-visible print:block">
      <div className={`
        h-screen sticky top-0 bg-slate-900 border-r border-slate-800 flex flex-col transition-all duration-300 z-50 overflow-hidden print:hidden
        ${isMobileMenuOpen ? 'translate-x-0 w-64' : '-translate-x-full md:translate-x-0 md:w-64'}
      `}>
        <div className="p-6 border-b border-slate-800 flex flex-col items-center gap-4 text-center overflow-hidden whitespace-nowrap">
          <div className="p-3 bg-white rounded-xl shadow-lg w-full flex justify-center flex-shrink-0 transition-all duration-300">
            <img src={MOPI_LOGO} alt="MOPI" className="h-10 object-contain" />
          </div>
          <div className="opacity-100 transition-opacity duration-300">
            <h1 className="font-bold text-white text-base leading-tight">Painel Docente</h1>
            <div className="flex items-center justify-center gap-2 mt-1">
              <p className="text-xs text-orange-400 font-semibold tracking-wider">{session.unit.toUpperCase()}</p>
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto py-4 px-3 space-y-4 custom-scrollbar">
          <div className="flex flex-col gap-2 w-full px-2">
            <button
              onClick={() => { setTeacherViewMode('welcome'); setIsMobileMenuOpen(false); }}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'welcome' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
              title="Início"
            >
              <Home className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Início</span>
            </button>
            <div className="h-px bg-slate-800 my-1"></div>
            <button
              onClick={() => { setTeacherViewMode('planner'); setIsMobileMenuOpen(false); }}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'planner' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
              title="Planejamento"
            >
              <FileSpreadsheet className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Planejamento</span>
            </button>
            <button
              onClick={() => { setTeacherViewMode('study_guide'); setIsMobileMenuOpen(false); }}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'study_guide' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
              title="Study Guide"
            >
              <BookOpen className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Study Guide</span>
            </button>

            {teacherViewMode !== 'planner' && (
              <>
                <button
                  onClick={() => { setTeacherViewMode('tutor_eleva'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'tutor_eleva' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                  title="Relatório do Tutor"
                >
                  <Sparkles className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Relatório do Tutor</span>
                </button>
                <button
                  onClick={() => { setTeacherViewMode('reformulator'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'reformulator' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                  title="Reformulador de Provas"
                >
                  <RefreshCw className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Reformulador Provas</span>
                </button>
                <button
                  onClick={() => { setTeacherViewMode('resources'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'resources' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                  title="Links e Documentos"
                >
                  <LinkIcon className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Links e Documentos</span>
                </button>
                <button
                  onClick={() => { setTeacherViewMode('question_adapter'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'question_adapter' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                  title="Adaptador de Questões"
                >
                  <Brain className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Adaptador Questões</span>
                </button>
                <button
                  onClick={() => { setTeacherViewMode('school_sync_va'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'school_sync_va' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                >
                  <CalendarRange size={18} className={teacherViewMode === 'school_sync_va' ? 'text-white' : 'text-slate-400'} />
                  <span>School Sync VA</span>
                </button>
                <button
                  onClick={() => { setTeacherViewMode('validator'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'validator' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                  title="Validador de Questões"
                >
                  <CheckCircle className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Validador Questões</span>
                </button>
                <button
                  onClick={() => { setTeacherViewMode('ctime'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'ctime' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                >
                  <Clock size={18} /> <span className="transition-all duration-200 overflow-hidden">C-Time / Janelas</span>
                </button>

                <button
                  onClick={() => { setTeacherViewMode('questiona'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'questiona' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                  title="QuestIonA"
                >
                  <Sparkles className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">QuestIonA</span>
                </button>

                <button
                  onClick={() => { setTeacherViewMode('timetable'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'timetable' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                >
                  <CalendarRange size={18} /> <span className="transition-all duration-200 overflow-hidden">Grade Horária</span>
                </button>
                <button
                  onClick={() => { setTeacherViewMode('atl_generator'); setIsMobileMenuOpen(false); }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-bold transition-all w-full text-left whitespace-nowrap ${teacherViewMode === 'atl_generator' ? 'bg-orange-600 text-white shadow-lg shadow-orange-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}
                  title="Gerador ATL"
                >
                  <FileText className="w-4 h-4 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Gerador ATL</span>
                </button>
              </>
            )}
          </div>

          {teacherViewMode === 'planner' && (
            <div className="space-y-1 mt-6">
              <p className="px-4 text-xs font-bold text-slate-500 uppercase mb-2 transition-opacity tracking-widest">Disciplinas</p>
              {currentGradeSubjects.map((subject) => (
                <button
                  key={subject}
                  onClick={() => {
                    setActiveSubject(subject);
                    setIsMobileMenuOpen(false);
                  }}
                  className={`
                    w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-all flex items-center justify-between group/btn
                    ${activeSubject === subject
                      ? 'bg-orange-600 text-white shadow-md'
                      : 'text-slate-400 hover:bg-slate-800 hover:text-white'}
                    `}
                >
                  <span className="flex items-center gap-3 whitespace-nowrap">
                    <BookOpen className={`w-4 h-4 flex-shrink-0 ${activeSubject === subject ? 'text-orange-200' : 'text-slate-400 group-hover/btn:text-slate-300'}`} />
                    <span className="transition-all duration-200 overflow-hidden">{subject}</span>
                  </span>
                  {activeSubject === subject && <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>}
                </button>
              ))}
            </div>
          )}

          <div className="transition-opacity duration-300">
            {teacherViewMode === 'welcome' && (
              <div className="px-4 py-6 text-slate-500 text-xs text-center italic">
                <p>Selecione uma área de atuação no painel lateral ou central.</p>
              </div>
            )}
          </div>
        </div>
        <div className="p-4 bg-slate-950 border-t border-slate-800 flex flex-col items-center">
          <div className="mb-2 text-xs text-slate-500 text-center truncate px-1 w-full transition-opacity" title={session.email}>
            {session.email}
          </div>
          <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 text-xs text-red-400 hover:text-red-300 py-2 hover:bg-slate-800 rounded transition-colors" title="Sair">
            <LogOut className="w-3 h-3 flex-shrink-0" /> <span className="transition-all duration-200 overflow-hidden">Sair</span>
          </button>
        </div>
      </div>
      <div className="flex-1 flex flex-col h-full overflow-hidden relative">
        <div className="md:hidden bg-white border-b border-gray-200 p-4 flex justify-between items-center">
          <img src={MOPI_LOGO} alt="MOPI" className="h-8" />
          <button onClick={() => setIsMobileMenuOpen(true)} className="p-2 text-slate-600">
            <Menu className="w-6 h-6" />
          </button>
        </div>
        {teacherViewMode === 'planner' && (
          <div className="bg-white border-b border-gray-200 px-6 pt-6 pb-0 shadow-sm z-20 flex flex-col gap-4">
            <div>
              <div className="flex items-center gap-3">
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                  <span className="text-blue-600">●</span> {activeSubject}
                </h2>
                <span className="px-2 py-0.5 rounded text-xs font-bold bg-orange-100 text-orange-700 border border-orange-200">
                  {session.unit}
                </span>
              </div>
              <p className="text-slate-500 text-sm mt-1">Selecione a série para visualizar o planejamento</p>
            </div>
            <div className="flex gap-1 overflow-x-auto pb-0 hide-scrollbar">
              {SERIES.map(grade => (
                <button
                  key={grade}
                  onClick={() => setActiveGrade(grade)}
                  className={`
                    px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors flex items-center gap-2
                    ${activeGrade === grade
                      ? 'border-orange-600 text-orange-600 bg-orange-50/50 rounded-t-lg'
                      : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}
                  `}
                >
                  <GraduationCap className={`w-4 h-4 ${activeGrade === grade ? 'text-orange-500' : 'text-slate-400'}`} />
                  {grade}
                </button>
              ))}
            </div>
          </div>
        )}
        <div className={`flex-1 relative bg-slate-50 ${teacherViewMode === 'planner' ? 'overflow-hidden' : 'overflow-y-auto'} print:bg-white print:overflow-visible print:static`}>
          {teacherViewMode === 'welcome' ? (
            <div className="min-h-full flex flex-col items-center py-16 px-8 animate-in fade-in zoom-in-95 duration-500">
              <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-slate-800 mb-4">Bem-vindo(a), Professor(a)!</h1>
                <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                  Selecione abaixo a área que deseja acessar neste momento. Você pode alternar entre elas a qualquer hora pelo menu lateral.
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6 w-full max-w-6xl">
                <button
                  onClick={() => setTeacherViewMode('school_sync_va')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <CalendarRange size={120} className="text-blue-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-blue-600">
                      <CalendarRange size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors">School Sync VA</h2>
                    <p className="text-slate-500 mb-6">Gerencie o calendário de Varied Assessments e evite sobrecarga acadêmica.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-blue-600 group-hover:mr-2 transition-all">
                      Abrir Calendário <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('planner')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <FileSpreadsheet size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <FileSpreadsheet size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Planejamento</h2>
                    <p className="text-slate-500 mb-6">Acesse seus quadros de planejamento, cronogramas e registros de aula.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar Planejamento <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('study_guide')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <BookOpen size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <BookOpen size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Study Guide</h2>
                    <p className="text-slate-500 mb-6">Crie guias de estudo personalizados para suas turmas.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar Guia <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                {/* <button
                  onClick={() => setTeacherViewMode('occurrences')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <AlertTriangle size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <AlertTriangle size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Ocorrências & Elogios</h2>
                    <p className="text-slate-500 mb-6">Registre ocorrências, envie elogios e acompanhe o comportamento dos alunos.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar Ocorrências <ChevronRight size={16} />
                    </span>
                  </div>
                </button> */}

                <button
                  onClick={() => setTeacherViewMode('validator')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <CheckCircle size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <CheckCircle size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Validador de Questões</h2>
                    <p className="text-slate-500 mb-6">Valide suas avaliações conforme BNCC/ENEM usando critérios pedagógicos rigorosos.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar Validador <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('tutor_eleva')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Sparkles size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <Sparkles size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Relatório do Tutor</h2>
                    <p className="text-slate-500 mb-6">Gere relatórios pedagógicos humanizados e personalizados com IA.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Criar Relatório <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('question_adapter')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Brain size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <Brain size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Adaptador de Questões</h2>
                    <p className="text-slate-500 mb-6">Utilize Inteligência Artificial para adaptar avaliações para alunos com TDAH, Dislexia ou Autismo.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar Adaptador <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('reformulator')}
                  className="group relative bg-orange-900 p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-orange-800 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <RefreshCw size={120} className="text-orange-300" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-950 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-300 border border-orange-300/30">
                      <RefreshCw size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-white mb-2 group-hover:text-orange-300 transition-colors">Reformulador de Provas</h2>
                    <p className="text-slate-300 mb-6">Gere provas de 2ª chamada e recuperação equivalentes baseadas nas questões originais.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-300 group-hover:mr-2 transition-all">
                      Acessar Reformulador <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('questiona')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Sparkles size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <Sparkles size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">QuestIonA</h2>
                    <p className="text-slate-500 mb-6">Acesse o criador inteligente de questões para suas avaliações.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar QuestIonA <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('atl_generator')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <FileText size={120} className="text-blue-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-blue-600">
                      <FileText size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors">Gerador ATL</h2>
                    <p className="text-slate-500 mb-6">Gere relatórios bilíngues por aluno (Learning Advice) com IA de forma rápida.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-blue-600 group-hover:mr-2 transition-all">
                      Abrir Gerador <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('resources')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <LinkIcon size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <LinkIcon size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Links e Documentos</h2>
                    <p className="text-slate-500 mb-6">Acesse arquivos, planilhas e plataformas oficiais da escola.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar Recursos <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('ctime')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Clock size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <Clock size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">C-Time / Janelas</h2>
                    <p className="text-slate-500 mb-6">Gerencie os horários de C-Time e janelas de atendimento.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar C-Time <ChevronRight size={16} />
                    </span>
                  </div>
                </button>

                <button
                  onClick={() => setTeacherViewMode('timetable')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
                    <CalendarRange size={120} className="text-orange-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-orange-600">
                      <CalendarRange size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-orange-600 transition-colors">Grade Horária</h2>
                    <p className="text-slate-500 mb-6">Visualize e gerencie a grade horária das turmas.</p>
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 group-hover:mr-2 transition-all">
                      Acessar Grade <ChevronRight size={16} />
                    </span>
                  </div>
                </button>


              </div>
            </div>
          ) : teacherViewMode === 'calendars' ? (
            <div className="h-full flex flex-col items-center justify-center p-8 animate-in fade-in zoom-in-95 duration-500">
              <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-slate-800 mb-4">Calendários Escolares</h1>
                <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                  Consulte abaixo as datas importantes, eventos e cronogramas do ano letivo.
                </p>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8 w-full max-w-5xl">
                <button
                  onClick={() => alert('Em breve')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                    <CalendarRange size={100} className="text-indigo-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-indigo-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-indigo-600">
                      <CalendarRange size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-indigo-600 transition-colors">Calendário Anual</h2>
                    <p className="text-slate-500">Visão completa do ano letivo com feriados, recessos e inícios de trimestre.</p>
                  </div>
                </button>

                <button
                  onClick={() => alert('Em breve')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                    <ClipboardCheck size={100} className="text-teal-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-teal-600">
                      <ClipboardCheck size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-teal-600 transition-colors">Calendário de Avaliações</h2>
                    <p className="text-slate-500">Datas das provas P1, P2 e Recuperações por série e disciplina.</p>
                  </div>
                </button>

                <button
                  onClick={() => alert('Em breve')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                    <PartyPopper size={100} className="text-pink-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-pink-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-pink-600">
                      <PartyPopper size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-pink-600 transition-colors">Eventos Pedagógicos</h2>
                    <p className="text-slate-500">Feira de Ciências, Festas, Reuniões de Pais e Conselhos de Classe.</p>
                  </div>
                </button>

                <button
                  onClick={() => alert('Em breve')}
                  className="group relative bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 overflow-hidden text-left"
                >
                  <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Bus size={100} className="text-amber-600" />
                  </div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform text-amber-600">
                      <Bus size={32} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-amber-600 transition-colors">Saídas e Viagens</h2>
                    <p className="text-slate-500">Cronograma de estudos do meio, passeios e viagens pedagógicas.</p>
                  </div>
                </button>
              </div>
            </div>
          ) : teacherViewMode === 'planner' ? (
            <ClassPlanner
              key={`${activeSubject}-${activeGrade}-${session.unit}`}
              subject={activeSubject}
              grade={activeGrade}
              teacherProfile={session}
              onToggleUnit={() => { }} // Disabled
            />
          ) : teacherViewMode === 'tutor_eleva' ? (
            <TutorEleva apiKey={geminiApiKey} />
          ) : teacherViewMode === 'question_adapter' ? (
            <QuestionAdapter apiKey={geminiApiKey} />
          ) : teacherViewMode === 'validator' ? (
            <QuestionValidator apiKey={"AQ.Ab8RN6L9xqG2T6VdoL7ChC1S_aV8DS1a1UWdXhScIx9CHlwsHQ"} />
          ) : teacherViewMode === 'reformulator' ? (
            <ReformuladorProva apiKey={geminiApiKey} />
          ) : teacherViewMode === 'study_guide' ? (
            <StudyGuideGenerator 
              db={db} 
              auth={auth} 
              currentUser={session} 
              appId={appId} 
              activeSubject={activeSubject} 
            />
          ) : teacherViewMode === 'resources' ? (
            <TeacherResources setTeacherViewMode={setTeacherViewMode} />
          ) : teacherViewMode === 'ctime' ? (
            <CommunityTimePanel />
          ) : teacherViewMode === 'timetable' ? (
            <NewTimetable />
          ) : teacherViewMode === 'school_sync_va' ? (
            <SchoolSyncVA auth={auth} db={db} session={session} userRole={session?.role} />
          ) : teacherViewMode === 'questiona' ? (
            <QuestionaCreator apiKey={globalApiKey} />
          ) : teacherViewMode === 'dashboard_evolucional' ? (
            <DashboardEvolucional db={db} auth={auth} session={session} />
          ) : teacherViewMode === 'atl_generator' ? (
            <div className="h-full w-full bg-white overflow-hidden">
              <iframe 
                src="/gerador_atl.html" 
                className="w-full h-full border-none" 
                title="Gerador ATL"
                style={{ height: 'calc(100vh - 0px)' }}
              />
            </div>
          ) : (
            <StudentOccurrences
              db={db}
              currentUser={session}
              appId={appId}
              classes={Object.values(CLASSES_BY_GRADE).flat()}
              trimestres={TRIMESTRES}
            />
          )}
        </div>
      </div>
    </div >
  );
}
